var data = {
  add_dataset_name: {
    tr: {
      caption: 'Dataset Adı',
      content: '<b>İpucu:</b> Dataset adını açık ve kapsayıcı olacak şekilde yazınız.<br>Örnek: <i>X konusunda gerçekleştirilen araştırmanın veri seti</i>.<br>Girişiniz sistem yönetimi tarafından kontrol edilerek gerekirse düzenlenir.',
      style: 'width: 520px;'
    },
    en: {
      caption: 'Dataset Name',
      content: '<b>Tip:</b> Use a clear and descriptive dataset name.<br>Example: <i>Dataset of a study conducted on X</i>.<br>Your entry may be reviewed and adjusted by the system administration.',
      style: 'width: 520px;'
    }
  },

  add_dataset_license_type: {
    tr: {
      caption: 'Dataset Lisans Türü',
      content: `<span style="font-weight: normal;"><section id="odc-license-compare" style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; padding: 40px 20px; background: linear-gradient(135deg, #e6f7f5, #e8f0ff);">
          <div style="max-width: 1100px; margin: 0 auto;">
            <h2 style="text-align: center; font-size: 28px; margin-bottom: 10px; color: #124b63;">
              ODC Lisans Karşılaştırması
            </h2>
            <p style="text-align: center; font-size: 15px; color: #355c7d; margin-bottom: 30px;">
              Dataset platformu üzerindeki veritabanları için lisans seçenekleri ve zorunlulukların kısa özeti.
            </p>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 20px;">
              <!-- ODbL Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">ODbL</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Open Database License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #e6f7ff; color: #0277bd; font-size: 11px; margin-bottom: 12px;">
                  Atıf + Aynı Lisansla Paylaş (Share-Alike)
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>Atıf zorunlu:</strong> Veritabanı kullanıldığında orijinal kaynağın belirtilmesi gerekir.</li>
                  <li>• <strong>Share-Alike:</strong> Türetilmiş veritabanları da ODbL ile lisanslanmalıdır.</li>
                  <li>• <strong>Değiştirme serbest:</strong> Veriye ekleme, çıkarma, dönüştürme yapılabilir.</li>
                  <li>• <strong>Ticari kullanım:</strong> Uygundur, lisans koşullarına uyulması kaydıyla.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Uygun kullanım örneği:</strong><br>
                  Veritabanından yeni bir klinik skor veri seti türetip, bunu da ODbL ile tekrar yayımlamak ve makalede dataset platformu kaynağına atıf yapmak.
                </div>
              </div>

              <!-- ODC-BY Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">ODC-BY</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Open Data Commons Attribution License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #e8f5e9; color: #2e7d32; font-size: 11px; margin-bottom: 12px;">
                  Atıf Zorunlu (BY = Attribution)
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>Atıf zorunlu:</strong> Her kullanımda orijinal veritabanına atıf yapılmalıdır.</li>
                  <li>• <strong>Share-Alike yok:</strong> Türetilmiş veritabanlarının lisansını farklı seçebilirsiniz.</li>
                  <li>• <strong>Değiştirme serbest:</strong> Veriyi birleştirme, filtreleme, dönüştürme mümkündür.</li>
                  <li>• <strong>Ticari kullanım:</strong> Uygundur, atıf şartı korunmalıdır.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Uygun kullanım örneği:</strong><br>
                  Veriyi kullanarak kapalı kaynak bir yapay zeka modeli eğitmek, fakat makale ve dokümantasyonda dataset platformuna atıf yapmak.
                </div>
              </div>

              <!-- PDDL Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">PDDL</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Public Domain Dedication and License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #fff3e0; color: #ef6c00; font-size: 11px; margin-bottom: 12px;">
                  En Serbest Lisans – Kamusal Alan Benzeri
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>Atıf zorunlu değil:</strong> Etik olarak atıf önerilir, ama lisans bunu zorunlu kılmaz.</li>
                  <li>• <strong>Share-Alike yok:</strong> Türetilmiş verileri istediğiniz lisansla sunabilirsiniz.</li>
                  <li>• <strong>Minimum kısıtlama:</strong> Kopyalama, değiştirme, yeniden kullanma serbesttir.</li>
                  <li>• <strong>Ticari kullanım:</strong> Tamamen serbesttir.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Uygun kullanım örneği:</strong><br>
                  Eğitim veya benchmarking amacıyla herkesin sınırsız kullanmasını istediğiniz tamamen açık bir simülasyon veri seti yayımlamak.
                </div>
              </div>
            </div>

            <!-- Mini Summary Table -->
            <div style="margin-top: 30px; background: rgba(255,255,255,0.85); border-radius: 16px; padding: 16px; box-shadow: 0 6px 16px rgba(0,0,0,0.04); overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                <thead>
                  <tr style="background: #f0f4ff; color: #0c3c4f;">
                    <th style="padding: 8px; text-align: left;">Lisans</th>
                    <th style="padding: 8px; text-align: left;">Atıf (BY)</th>
                    <th style="padding: 8px; text-align: left;">Share-Alike</th>
                    <th style="padding: 8px; text-align: left;">Ticari Kullanım</th>
                    <th style="padding: 8px; text-align: left;">Tipik Kullanım Senaryosu</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">ODbL</td>
                    <td style="padding: 8px;">Zorunlu</td>
                    <td style="padding: 8px;">Zorunlu (türetilen veritabanı)</td>
                    <td style="padding: 8px;">Uygun</td>
                    <td style="padding: 8px;">Açık kalması istenen ama lisans uyumluluğu da şart koşulan veritabanları</td>
                  </tr>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">ODC-BY</td>
                    <td style="padding: 8px;">Zorunlu</td>
                    <td style="padding: 8px;">Yok</td>
                    <td style="padding: 8px;">Uygun</td>
                    <td style="padding: 8px;">Atıf alınması yeterli olan, türetilmiş işlerde esneklik tanınan verisetleri</td>
                  </tr>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">PDDL</td>
                    <td style="padding: 8px;">Zorunlu değil (etik olarak önerilir)</td>
                    <td style="padding: 8px;">Yok</td>
                    <td style="padding: 8px;">Tam serbest</td>
                    <td style="padding: 8px;">Maksimum özgürlük istenen, herkesin sınırsız kullanabilmesi amaçlanan verisetleri</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        </span>`,
      style: 'width: 980px;'
    },
    en: {
      caption: 'Dataset License Type',
      content: `<span style="font-weight: normal;">
        <section id="odc-license-compare" style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; padding: 40px 20px; background: linear-gradient(135deg, #e6f7f5, #e8f0ff);">
          <div style="max-width: 1100px; margin: 0 auto;">
            <h2 style="text-align: center; font-size: 28px; margin-bottom: 10px; color: #124b63;">
              ODC License Comparison
            </h2>
            <p style="text-align: center; font-size: 15px; color: #355c7d; margin-bottom: 30px;">
              A concise overview of license options and obligations for databases hosted on dataset platform.
            </p>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 20px;">
              <!-- ODbL Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">ODbL</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Open Database License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #e6f7ff; color: #0277bd; font-size: 11px; margin-bottom: 12px;">
                  Attribution + Share-Alike
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>Attribution required:</strong> The original source must be credited whenever the database is used.</li>
                  <li>• <strong>Share-Alike:</strong> Derived databases must also be licensed under ODbL.</li>
                  <li>• <strong>Modification allowed:</strong> Data may be added, removed, or transformed.</li>
                  <li>• <strong>Commercial use:</strong> Permitted, provided license terms are respected.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Appropriate use example:</strong><br>
                  Deriving a new clinical scoring dataset from the database, republishing it under ODbL, and citing dataset platform as the source in the manuscript.
                </div>
              </div>

              <!-- ODC-BY Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">ODC-BY</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Open Data Commons Attribution License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #e8f5e9; color: #2e7d32; font-size: 11px; margin-bottom: 12px;">
                  Attribution Required (BY)
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>Attribution required:</strong> Proper credit must be given for every use.</li>
                  <li>• <strong>No Share-Alike:</strong> You may choose a different license for derived databases.</li>
                  <li>• <strong>Modification allowed:</strong> Data may be merged, filtered, or transformed.</li>
                  <li>• <strong>Commercial use:</strong> Permitted, as long as attribution is preserved.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Appropriate use example:</strong><br>
                  Training a proprietary AI model using the data, while citing the dataset platform in publications and documentation.
                </div>
              </div>

              <!-- PDDL Card -->
              <div style="background: #ffffff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); padding: 20px;">
                <h3 style="font-size: 20px; margin-bottom: 6px; color: #0c3c4f;">PDDL</h3>
                <p style="font-size: 13px; color: #4a6572; margin: 0 0 10px;">Public Domain Dedication and License</p>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 999px; background: #fff3e0; color: #ef6c00; font-size: 11px; margin-bottom: 12px;">
                  Most Permissive – Public Domain–Like
                </span>

                <ul style="list-style: none; padding: 0; margin: 0; font-size: 13px; color: #37474f;">
                  <li>• <strong>No attribution required:</strong> Attribution is ethically recommended but not legally mandatory.</li>
                  <li>• <strong>No Share-Alike:</strong> Derived data may be released under any license.</li>
                  <li>• <strong>Minimal restrictions:</strong> Copying, modifying, and reuse are fully permitted.</li>
                  <li>• <strong>Commercial use:</strong> Completely unrestricted.</li>
                </ul>

                <div style="margin-top: 12px; font-size: 12px; color: #607d8b;">
                  <strong>Appropriate use example:</strong><br>
                  Publishing a fully open simulation dataset intended for unrestricted educational or benchmarking use by anyone.
                </div>
              </div>
            </div>

            <!-- Mini Summary Table -->
            <div style="margin-top: 30px; background: rgba(255,255,255,0.85); border-radius: 16px; padding: 16px; box-shadow: 0 6px 16px rgba(0,0,0,0.04); overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                <thead>
                  <tr style="background: #f0f4ff; color: #0c3c4f;">
                    <th style="padding: 8px; text-align: left;">License</th>
                    <th style="padding: 8px; text-align: left;">Attribution (BY)</th>
                    <th style="padding: 8px; text-align: left;">Share-Alike</th>
                    <th style="padding: 8px; text-align: left;">Commercial Use</th>
                    <th style="padding: 8px; text-align: left;">Typical Use Case</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">ODbL</td>
                    <td style="padding: 8px;">Required</td>
                    <td style="padding: 8px;">Required (derived databases)</td>
                    <td style="padding: 8px;">Allowed</td>
                    <td style="padding: 8px;">Databases intended to remain open with enforced license compatibility</td>
                  </tr>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">ODC-BY</td>
                    <td style="padding: 8px;">Required</td>
                    <td style="padding: 8px;">None</td>
                    <td style="padding: 8px;">Allowed</td>
                    <td style="padding: 8px;">Datasets where attribution is sufficient and derivative works remain flexible</td>
                  </tr>
                  <tr style="border-top: 1px solid #e0e0e0;">
                    <td style="padding: 8px;">PDDL</td>
                    <td style="padding: 8px;">Not required (ethically recommended)</td>
                    <td style="padding: 8px;">None</td>
                    <td style="padding: 8px;">Fully unrestricted</td>
                    <td style="padding: 8px;">Datasets intended for maximum freedom and unlimited public reuse</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        </span>
        `,
      style: 'width: 620px;'
    }
  },

    which_best_describes_reason_for_sharing_dataset: {
      tr: {
        caption: 'Dataset Paylaşma Amacınız',
        content: `<span style="font-weight: normal;">
          <div style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; padding: 18px 18px; background: linear-gradient(135deg, #eef7ff, #eafaf4); border-radius: 14px; border: 1px solid rgba(0,0,0,0.06); width: 100%; box-sizing: border-box;">
            <div style="font-size: 14px; color: #1f3b4d; margin-bottom: 10px;">
              Bu alan, dataset’i <b>neden paylaştığınızı</b> belirtmenizi sağlar. Seçiminiz; profilinizin nasıl görüneceğini, kullanıcıların dataset’e nasıl yaklaşacağını ve destek ekibinin sizi doğru şekilde yönlendirmesini kolaylaştırır.
            </div>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 12px; margin-top: 10px;">
              
              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #e8f0ff; color: #1b4fb6; margin-bottom: 10px;">
                  İş Birliği
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  Ortak araştırmacı arıyorum
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Bu seçeneği, dataset ile birlikte çalışacak <b>birlikte yayın üretebileceğiniz</b> araştırmacılar arıyorsanız seçin.
                  Genellikle “misafir araştırmacı / ortak ekip” süreçleri ve iletişim köprüsü bu amaçla aktive edilir.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Ne zaman uygun?</b> Multidisipliner ekip kurmak, dış merkez validasyon, yeni analiz planlamak.
                </div>
              </div>

              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #eaf7ff; color: #0a6aa6; margin-bottom: 10px;">
                  Yayın Referansı
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  Makaleye veri linki eklemek istiyorum
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Bu seçeneği, yayımladığınız / yayımlayacağınız makalede dataset’inize ait <b>kalıcı bir bağlantı</b> (dataset sayfası linki, DOI/Handle vb.) vermek istiyorsanız seçin.
                  Böylece araştırmanızın “veri erişimi” bölümü daha şeffaf olur.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Ne zaman uygun?</b> Data Availability Statement, dergi zorunluluğu, reprodüksiyon/şeffaflık.
                </div>
              </div>

              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #e9fff1; color: #1d7a3a; margin-bottom: 10px;">
                  Etki / Yeniden Kullanım
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  Dataset’imle yeni araştırmalar üretilsin istiyorum
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Bu seçeneği, dataset’inizin başka araştırmacılar tarafından <b>yeni projeler, analizler ve modeller</b> üretmek için kullanılmasını hedefliyorsanız seçin.
                  Amaç, dataset’in bilime katkısını ve görünürlüğünü artırmaktır.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Ne zaman uygun?</b> Benchmark veri seti, ikincil analiz, meta-analiz / model geliştirme.
                </div>
              </div>

            </div>

            <div style="margin-top: 12px; font-size: 12px; color: #5a6f7e; padding-top: 10px; border-top: 1px dashed rgba(0,0,0,0.12);">
              <b>Not:</b> Seçiminiz daha sonra güncellenebilir. Kararsızsanız, baskın motivasyonunuzu seçmeniz yeterlidir.
            </div>
          </div>
        </span>`,
        style: 'width: 860px;'
      },
      en: {
        caption: 'Your Purpose for Sharing the Dataset',
        content: `<span style="font-weight: normal;">
          <div style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; padding: 18px 18px; background: linear-gradient(135deg, #eef7ff, #eafaf4); border-radius: 14px; border: 1px solid rgba(0,0,0,0.06); width: 100%; box-sizing: border-box;">
            <div style="font-size: 14px; color: #1f3b4d; margin-bottom: 10px;">
              This field helps you specify <b>why you are sharing</b> your dataset. Your choice guides how the dataset is presented and helps others understand your main intent.
            </div>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 12px; margin-top: 10px;">
              
              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #e8f0ff; color: #1b4fb6; margin-bottom: 10px;">
                  Collaboration
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  I am looking for a co-researcher
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Choose this if you want to find collaborators who can <b>work with you</b> and potentially co-author publications based on this dataset.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Typical use:</b> building a multi-center team, external validation, planning new analyses.
                </div>
              </div>

              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #eaf7ff; color: #0a6aa6; margin-bottom: 10px;">
                  Publication Link
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  I want to add a data link to the article
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Choose this if your main goal is to include a <b>persistent dataset link</b> (dataset page, DOI/Handle, etc.) in your publication’s Data Availability section.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Typical use:</b> journal requirements, transparency, reproducibility.
                </div>
              </div>

              <div style="background: #ffffff; border-radius: 14px; padding: 14px; box-shadow: 0 6px 16px rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.04);">
                <div style="display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 999px; background: #e9fff1; color: #1d7a3a; margin-bottom: 10px;">
                  Impact & Reuse
                </div>
                <div style="font-size: 16px; font-weight: 700; color: #123b5a; margin-bottom: 6px;">
                  I want new research to be generated using my dataset
                </div>
                <div style="font-size: 13px; color: #3b5566; line-height: 1.5;">
                  Choose this if you want other researchers to reuse your dataset to create <b>new studies, analyses, and models</b>, increasing visibility and scientific impact.
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #5a6f7e;">
                  <b>Typical use:</b> benchmark datasets, secondary analyses, model development.
                </div>
              </div>

            </div>

            <div style="margin-top: 12px; font-size: 12px; color: #5a6f7e; padding-top: 10px; border-top: 1px dashed rgba(0,0,0,0.12);">
              <b>Note:</b> You can update this later. If unsure, select the option that best matches your primary motivation.
            </div>
          </div>
        </span>`,
        style: 'width: 860px;'
      }
    },

    dataset_creator_note: {
      tr: {
        caption: 'Dataset Oluşturucu Notu',
        content: '<b>Bilgilendirme:</b> Bu alan yalnızca sistem yönetimi tarafından görüntülenir.<br>Dataset ile ilgili ek açıklama, özel durum veya iletmek istediğiniz bir not varsa bu bölüme yazabilirsiniz.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Dataset Creator Note',
        content: '<b>Information:</b> This field is visible only to the system administrators.<br>You may use this area to leave an internal note, special request, or additional explanation regarding the dataset.',
        style: 'width: 520px;'
      }
    },

    communication_with_user_requesting_dataset: {
      tr: {
        caption: 'Dataset Talep Eden Kullanıcı ile İletişim',
        content: '<b>Açıklama:</b> Bu seçenek <b>Evet</b> olarak işaretlendiğinde, dataset’e abone olmak isteyen kullanıcıların sizinle doğrudan iletişim kurabilmesine izin verilir.<br><br>Bu kapsamda;<ul style="margin: 6px 0 0 16px;"><li>Telefon numaranızı</li><li>E-posta adresinizi</li><li>İletilmesini istediğiniz kısa bir notu</li></ul>ekleyebilirsiniz.<br><br>Paylaştığınız iletişim bilgileri yalnızca dataset talep eden aboneler tarafından görüntülenir.',
        style: 'width: 600px;'
      },
      en: {
        caption: 'Communication With Dataset Requesting Users',
        content: '<b>Description:</b> When this option is set to <b>Yes</b>, users requesting access to the dataset will be allowed to contact you directly.<br><br>You may provide;<ul style="margin: 6px 0 0 16px;"><li>Your phone number</li><li>Your email address</li><li>A short message you would like to share</li></ul><br>Shared contact details will be visible only to users requesting the dataset.',
        style: 'width: 600px;'
      }
    },

    about_dataset: {
      tr: {
        caption: 'Dataset Hakkında',
        content: '<b>Açıklama:</b> Bu bölümde yer alan bilgiler, dataset’in tanıtım sayfasında kullanıcılara sunulur.<br><br>Dataset’e ait araştırmanın <b>temel amacını</b> açıkça yansıtan, gerçekleştirilmesi hedeflenen veya tamamlanmış <b>en temel analizleri</b> özetleyen bir açıklama yazmanız beklenir.<br><br>Metnin; kısa, anlaşılır ve araştırmanın kapsamını net biçimde ifade eden bir özet niteliğinde olması önerilir.',
        style: 'width: 620px;'
      },
      en: {
        caption: 'About the Dataset',
        content: '<b>Description:</b> The information provided in this section will be displayed to users on the dataset’s public introduction page.<br><br>Please include a concise summary that clearly reflects the <b>primary objective</b> of the research and briefly describes the <b>key analyses</b> that are planned or have already been conducted using the dataset.<br><br>The text should be clear, concise, and accurately represent the scope of the research.',
        style: 'width: 620px;'
      }
    },

    demo_dataset: {
      tr: {
        caption: 'Demo Dataset',
        content: '<b>Açıklama:</b> Bu alan, paylaşılan dataset’in <b>demo</b> olup olmadığını belirtir.<br><br><ul style="margin-left:16px;"><li><b>No</b> olarak işaretlendiğinde, paylaşılan dataset <b>tam veriyi</b> içeren eksiksiz bir veri setidir.</li><li><b>Yes</b> olarak işaretlendiğinde, dataset’te yer alan <b>tüm satırlar eksiksizdir</b> ancak veri, <b>demo amaçlı</b> olarak sunulmaktadır.</li></ul><br>Demo dataset’ler genellikle <b>dataset abonesi ile iletişim kurma</b> ve <b>ortak araştırma geliştirme</b> amacıyla paylaşılabilir.',
        style: 'width: 620px;'
      },
      en: {
        caption: 'Demo Dataset',
        content: '<b>Description:</b> This field indicates whether the shared dataset is a <b>demo</b> dataset.<br><br><ul style="margin-left:16px;"><li>When set to <b>No</b>, the dataset represents a <b>complete dataset</b> containing the full data.</li><li>When set to <b>Yes</b>, all rows in the dataset are <b>complete</b>, but the dataset is shared for <b>demonstration purposes</b>.</li></ul><br>Demo datasets may be shared to <b>initiate communication</b> with dataset subscribers and to support <b>collaborative research</b> opportunities.',
        style: 'width: 620px;'
      }
    },

    row_count: {
      tr: {
        caption: 'Satır Sayısı',
        content: '<b>Açıklama:</b> Bu alanda, veri setinde bulunan <b>toplam satır sayısı</b> belirtilir.<br><br>Girilen değer, kullanıcıların veri setinin kapsamını ve büyüklüğünü hızlıca anlamasına yardımcı olur.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Row Count',
        content: '<b>Description:</b> This field specifies the <b>total number of rows</b> contained in the dataset.<br><br>The provided value helps users quickly understand the size and scope of the dataset.',
        style: 'width: 520px;'
      }
    },

    column_count: {
      tr: {
        caption: 'Kolon Sayısı',
        content: '<b>Açıklama:</b> Bu alanda, veri setinde bulunan <b>toplam kolon sayısı</b> belirtilir.<br><br>Girilen değer, kullanıcıların veri setinin kapsamını ve büyüklüğünü hızlıca anlamasına yardımcı olur.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Column Count',
        content: '<b>Description:</b> This field specifies the <b>total number of columns</b> contained in the dataset.<br><br>The provided value helps users quickly understand the size and scope of the dataset.',
        style: 'width: 520px;'
      }
    },


    dataset_usage_type: {
      tr: {
        caption: 'Dataset Kullanım Şekli',
        content: `
          <b>Açıklama:</b> Bu alanda, dataset’in bilimsel çalışmalarda <b>hangi koşullarda kullanılmasını istediğinizi</b> belirtirsiniz.
          <br><br>
          <ul style="margin-left:16px;">
            <li>
              <b>Dataset yükleyicisi ile iş birliği</b> seçeneğini işaretleyiniz;
              eğer dataset’i paylaşan kişi ile dataset’i kullanan araştırmacının,
              ortaya çıkacak makale veya çalışmada <b>yazar olarak birlikte yer alması</b>
              bekleniyorsa.
            </li>
            <li>
              <b>Araştırmacı kendi çalışmasını yürütebilir</b> seçeneğini işaretleyiniz;
              eğer dataset’i paylaşan kişi makalede yazar olmak istemiyor ancak:
              <ul style="margin-left:16px; margin-top:6px;">
                <li>çalışmanın <b>teşekkür (acknowledgement)</b> bölümünde belirtilmeyi ve</li>
                <li>
                  dataset’in kullanıldığı tüm makale, rapor, sunum ve projelerde
                  dataset’e ve dataset ile ilişkili yayınlara
                  <b>uygun akademik atıf (citation)</b> yapılmasını
                </li>
              </ul>
              talep ediyorsa.
            </li>
          </ul>
          <br>
          Seçiminiz; yazarlık, teşekkür ve atıf beklentilerini açıkça tanımlar ve
          dataset kullanım koşullarını aboneler için netleştirir.
        `,
        style: 'width: 720px;'
      },
      en: {
        caption: 'Dataset Usage Type',
        content: `
          <b>Description:</b> This field defines <b>the conditions under which the dataset may be used</b> in scientific research.
          <br><br>
          <ul style="margin-left:16px;">
            <li>
              Select <b>Collaboration with the dataset uploader</b> if both the dataset provider
              and the dataset subscriber are expected to be <b>co-authors</b> on the resulting
              publication or study.
            </li>
            <li>
              Select <b>Researcher may conduct their own research</b> if the dataset provider
              does not wish to be listed as an author, but requests that:
              <ul style="margin-left:16px; margin-top:6px;">
                <li>they are acknowledged in the <b>acknowledgement</b> section, and</li>
                <li>
                  the dataset and any related publications are
                  <b>properly cited</b> in all articles, reports, presentations, or projects
                  derived from the dataset
                </li>
              </ul>
            </li>
          </ul>
          <br>
          Your selection clearly defines authorship, acknowledgement, and citation expectations
          for dataset subscribers.
        `,
        style: 'width: 720px;'
      }
    },


    special_acknowledgement_request_status: {
      tr: {
        caption: 'Özel Teşekkür Talebi',
        content: '<b>Açıklama:</b> Bu alanda, veri seti kullanılarak üretilen <b>makalelerde veya sunumlarda</b> özel bir teşekkür (acknowledgement) metni talep edilip edilmediği belirtilir.<br><br>Eğer özel bir teşekkür ifadesi isteniyorsa, bu tercih ilgili araştırmacılara kullanım koşulları kapsamında gösterilir.',
        style: 'width: 620px;'
      },
      en: {
        caption: 'Special Acknowledgement Request',
        content: '<b>Description:</b> This field indicates whether a <b>specific acknowledgement statement</b> is requested in publications or presentations produced using the dataset.<br><br>If a special acknowledgement is required, this preference will be communicated to researchers as part of the dataset usage conditions.',
        style: 'width: 620px;'
      }
    },


    dataset_authors: {
      tr: {
        caption: 'Dataset Yazarları',
        content: '<b>Açıklama:</b> Bu alanda, veri seti ile birlikte araştırmayı oluşturan <b>yazarlar listesi</b> belirtilir.<br><br>Belirtilen yazarlar, veri seti mağaza ekranında <b>dataset’in altında sıralı şekilde</b> listelenir.<br><br>Ayrıca, her bir yazarın <b>araştırmacı profil sayfasında</b>, ilgili dataset <b>katkı sağladığı veri setleri</b> arasında görüntülenir.',
        style: 'width: 640px;'
      },
      en: {
        caption: 'Dataset Authors',
        content: '<b>Description:</b> This section lists the <b>authors who contributed to the research</b> associated with the dataset.<br><br>The specified authors are displayed <b>in order under the dataset</b> on the dataset marketplace page.<br><br>In addition, the dataset appears on each author’s <b>researcher profile page</b> under the list of datasets to which they have contributed.',
        style: 'width: 640px;'
      }
    },

    author_title: {
      tr: {
        caption: 'Yazar Ünvanı',
        content: '<b>Açıklama:</b> Yazarın akademik veya profesyonel ünvanını belirtiniz.<br><br>Örnek: Prof. Dr., Doç. Dr., Dr., Araş. Gör., Öğr. Gör.',
        style: 'width: 480px;'
      },
      en: {
        caption: 'Author Title',
        content: '<b>Description:</b> Specify the academic or professional title of the author.<br><br>Example: Prof., Assoc. Prof., Dr., Research Assistant.',
        style: 'width: 480px;'
      }
    },

    author_firstname: {
      tr: {
        caption: 'Yazar Adı',
        content: '<b>Açıklama:</b> Yazarın <b>adını</b> giriniz.<br><br>Bu bilgi, dataset sayfasında ve araştırmacı profilinde görüntülenir.',
        style: 'width: 480px;'
      },
      en: {
        caption: 'Author First Name',
        content: '<b>Description:</b> Enter the <b>first name</b> of the author.<br><br>This information is displayed on the dataset page and researcher profile.',
        style: 'width: 480px;'
      }
    },

    author_lastname: {
      tr: {
        caption: 'Yazar Soyadı',
        content: '<b>Açıklama:</b> Yazarın <b>soyadını</b> giriniz.<br><br>Ad–soyad bilgisi, yazar sıralamasında ve atıf görünümünde birlikte kullanılır.',
        style: 'width: 480px;'
      },
      en: {
        caption: 'Author Last Name',
        content: '<b>Description:</b> Enter the <b>last name</b> of the author.<br><br>First and last names are used together for author listing and citation display.',
        style: 'width: 480px;'
      }
    },

    author_mail: {
      tr: {
        caption: 'Yazar E-Posta Adresi',
        content: '<b>Açıklama:</b> Yazarın aktif <b>e-posta adresini</b> belirtiniz.<br><br>Bu bilgi, gerektiğinde akademik iletişim ve doğrulama amaçlı kullanılabilir.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Author Email Address',
        content: '<b>Description:</b> Enter the author’s active <b>email address</b>.<br><br>This information may be used for academic communication and verification purposes.',
        style: 'width: 520px;'
      }
    },

    author_institution: {
      tr: {
        caption: 'Yazar Kurumu',
        content: '<b>Açıklama:</b> Yazarın bağlı olduğu <b>kurum veya üniversite</b> bilgisini giriniz.<br><br>Örnek: İstinye Üniversitesi, Tıp Fakültesi',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Author Institution',
        content: '<b>Description:</b> Specify the <b>institution or university</b> the author is affiliated with.<br><br>Example: XYZ University, Faculty of Medicine',
        style: 'width: 520px;'
      }
    },

    author_orcid_id: {
      tr: {
        caption: 'Yazar ORCID ID',
        content: '<b>Açıklama:</b> Yazarın <b>ORCID kimlik numarasını</b> giriniz.<br><br>ORCID ID, araştırmacının akademik kimliğini benzersiz olarak tanımlar ve yayınlarla eşleştirilmesini sağlar.<br><br>Örnek: 0000-0002-1825-0097',
        style: 'width: 560px;'
      },
      en: {
        caption: 'Author ORCID ID',
        content: '<b>Description:</b> Enter the author’s <b>ORCID identifier</b>.<br><br>The ORCID ID uniquely identifies the researcher and links their academic outputs.<br><br>Example: 0000-0002-1825-0097',
        style: 'width: 560px;'
      }
    },

    applied_methodology_and_analyses: {
      tr: {
        caption: 'Uygulanan Metodoloji ve Analizler',
        content: '<b>Açıklama:</b> Bu bölümde, veri seti kullanılarak araştırma makalesi yazımında uygulanan <b>metodoloji ve analiz yöntemlerini</b> belirtiniz.<br><br>Paylaşılan bu bilgiler sayesinde aboneler; <b>farklı veri filtreleri</b>, <b>alternatif analiz yaklaşımları</b> veya <b>farklı metodolojiler</b> kullanarak kendi araştırmalarını planlayabilir ve gerçekleştirebilirler.<br><br>Metnin; kullanılan temel yöntemleri, analiz akışını ve tercih edilen istatistiksel / hesaplamalı yaklaşımları özetlemesi önerilir.',
        style: 'width: 700px;'
      },
      en: {
        caption: 'Applied Methodology and Analyses',
        content: '<b>Description:</b> In this section, describe the <b>methodologies and analytical approaches</b> applied when preparing research articles using the dataset.<br><br>Providing this information enables subscribers to design their own studies using <b>different data filters</b>, <b>alternative analytical strategies</b>, or <b>distinct methodologies</b> based on the same dataset.<br><br>The text should summarize the main methods, analysis workflow, and preferred statistical or computational techniques.',
        style: 'width: 700px;'
      }
    },


    data_collection_center_count: {
      tr: {
        caption: 'Veri Toplama Merkezi Sayısı',
        content: '<b>Açıklama:</b> Bu alanda, veri setinin üretilmesi sürecinde <b>kaç farklı merkezden veri toplandığı</b> belirtilir.<br><br>Bilgi <b>sayısal değer</b> olarak girilmelidir ve veri setinin <b>tek merkezli</b> ya da <b>çok merkezli</b> olduğunu açıkça gösterir.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Data Collection Center Count',
        content: '<b>Description:</b> This field specifies the <b>number of centers</b> from which data were collected during the creation of the dataset.<br><br>The value should be provided as a <b>numeric entry</b> and clearly indicates whether the dataset is <b>single-center</b> or <b>multi-center</b>.',
        style: 'width: 520px;'
      }
    },

    data_collection_centers: {
      tr: {
        caption: 'Veri Toplama Merkezleri',
        content: '<b>Açıklama:</b> Bu alanda, veri setinin oluşturulması sırasında verinin sağlandığı <b>merkezlerin veya kurumların adları</b> belirtilebilir.<br><br>Bilgilerin açık ve kurumsal adlarıyla yazılması, veri setinin kaynak şeffaflığını ve akademik güvenilirliğini artırır.',
        style: 'width: 600px;'
      },
      en: {
        caption: 'Data Collection Centers',
        content: '<b>Description:</b> This section allows you to specify the <b>institutions or centers</b> that provided data during the creation of the dataset.<br><br>Listing clear institutional names enhances transparency and academic credibility of the dataset.',
        style: 'width: 600px;'
      }
    },

    dataset_publication_status_in_an_article: {
      tr: {
        caption: 'Makalede Yayınlanma Durumu',
        content: '<b>Açıklama:</b> Veri seti kullanılarak <b>en az bir makale üretilmişse</b> bu alan <b>Yes</b> olarak işaretlenir.<br><br>Veri seti ile ilişkili <b>makale veya makaleler</b> daha sonra sisteme eklenebilir.<br><br>Veri seti aboneleri, kendi çalışmalarında bu makalelere <b>kaynak olarak atıf yapacaktır</b>.',
        style: 'width: 680px;'
      },
      en: {
        caption: 'Publication Status in an Article',
        content: '<b>Description:</b> Select <b>Yes</b> if <b>one or more articles</b> have been produced using the dataset.<br><br>Additional articles related to the dataset can be added later.<br><br>Dataset subscribers are expected to <b>cite these articles</b> in their own publications.',
        style: 'width: 680px;'
      }
    },

    journal_name: {
      tr: {
        caption: 'Dergi Adı',
        content: '<b>Açıklama:</b> Veri seti kullanılarak üretilen makalenin yayımlandığı <b>bilimsel derginin adını</b> belirtiniz.<br><br>Bu bilgi, veri seti ile ilişkili yayınların doğru şekilde tanımlanmasını sağlar.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Journal Name',
        content: '<b>Description:</b> Specify the <b>name of the scientific journal</b> in which the article produced using the dataset was published.<br><br>This helps correctly identify publications associated with the dataset.',
        style: 'width: 520px;'
      }
    },

    article_title: {
      tr: {
        caption: 'Makale Başlığı',
        content: '<b>Açıklama:</b> Veri seti kullanılarak üretilen makalenin <b>tam başlığını</b> giriniz.<br><br>Başlık, yayında yer aldığı şekliyle eksiksiz olmalıdır.',
        style: 'width: 560px;'
      },
      en: {
        caption: 'Article Title',
        content: '<b>Description:</b> Enter the <b>full title</b> of the article produced using the dataset.<br><br>The title should exactly match the published version.',
        style: 'width: 560px;'
      }
    },

    article_link: {
      tr: {
        caption: 'Makale Linki',
        content: '<b>Açıklama:</b> Makalenin yayımlandığı sayfaya ait <b>doğrudan bağlantıyı</b> (DOI, PubMed, dergi sayfası vb.) giriniz.<br><br>Bu bağlantı, abonelerin makaleye hızlıca erişmesini sağlar.',
        style: 'width: 600px;'
      },
      en: {
        caption: 'Article Link',
        content: '<b>Description:</b> Provide the <b>direct link</b> to the published article (DOI, PubMed, journal page, etc.).<br><br>This allows subscribers to easily access the publication.',
        style: 'width: 600px;'
      }
    },

    article_authors: {
      tr: {
        caption: 'Makale Yazarları',
        content: '<b>Açıklama:</b> Veri seti kullanılarak üretilen makalede yer alan <b>yazarların tam listesini</b> belirtiniz.<br><br>Yazarların sırası, makalede yer aldığı sıraya uygun olmalıdır.',
        style: 'width: 620px;'
      },
      en: {
        caption: 'Article Authors',
        content: '<b>Description:</b> List the <b>full names of the authors</b> included in the article produced using the dataset.<br><br>The order should follow the author sequence in the published article.',
        style: 'width: 620px;'
      }
    },

    ethics_committee_approval_institution: {
      tr: {
        caption: 'Etik Kurul Onay Kurumu',
        content: '<b>Açıklama:</b> Veri setinin oluşturulması veya kullanımı için onay veren <b>etik kurulun bağlı olduğu kurumun adını</b> belirtiniz.<br><br>Örnek: İstinye Üniversitesi Etik Kurulu',
        style: 'width: 600px;'
      },
      en: {
        caption: 'Ethics Committee Approval Institution',
        content: '<b>Description:</b> Specify the <b>institution name</b> of the ethics committee that approved the creation or use of the dataset.<br><br>Example: XYZ University Ethics Committee',
        style: 'width: 600px;'
      }
    },

    ethics_committee_date: {
      tr: {
        caption: 'Etik Kurul Onay Tarihi',
        content: '<b>Açıklama:</b> Etik kurul onayının alındığı <b>tarihi</b> belirtiniz.<br><br>Tarihin resmi onay belgesinde yer aldığı formatta girilmesi önerilir.',
        style: 'width: 520px;'
      },
      en: {
        caption: 'Ethics Committee Approval Date',
        content: '<b>Description:</b> Enter the <b>date</b> on which the ethics committee approval was granted.<br><br>It is recommended to use the date format shown on the official approval document.',
        style: 'width: 520px;'
      }
    },

    ethics_committee_protocol_number: {
      tr: {
        caption: 'Etik Kurul Protokol Numarası',
        content: '<b>Açıklama:</b> Etik kurul tarafından verilen <b>protokol / karar numarasını</b> giriniz.<br><br>Bu numara, etik onayın doğrulanabilirliğini sağlar.',
        style: 'width: 560px;'
      },
      en: {
        caption: 'Ethics Committee Protocol Number',
        content: '<b>Description:</b> Provide the <b>protocol or approval number</b> assigned by the ethics committee.<br><br>This number enables verification of the ethical approval.',
        style: 'width: 560px;'
      }
    },

    excel_file: {
      tr: {
        caption: 'Excel Dosyası',
        content: '<b>Bilgilendirme:</b> Excel verinizi yüklemeden önce <a href="/veri-yukleme" target="_blank">veri yükleme kılavuzumuzu</a> mutlaka okuduğunuzdan emin olunuz.<br><br>Ayrıca, kişisel verilerin korunması ve veri güvenliği açısından <a href="/anonimizasyon" target="_blank">anonimizasyon kılavuzumuzu</a> incelemeniz gerekmektedir.',
        style: 'width: 720px;'
      },
      en: {
        caption: 'Excel File',
        content: '<b>Information:</b> Before uploading your Excel file, please make sure you have reviewed our <a href="/data-upload" target="_blank">data upload guide</a>.<br><br>In addition, we strongly recommend reviewing the <a href="/anonimization" target="_blank">anonymization guide</a> to ensure data privacy and security.',
        style: 'width: 720px;'
      }
    },

    dataset_general_information: {
      tr: {
        caption: 'Dataset Genel Bilgilendirme',
        content: '<b>Bilgilendirme:</b> Veri setiniz, sistem yöneticisi tarafından kontrol edilip <b>genel düzenlemeler</b> ve <b>dil kontrolleri</b> yapıldıktan sonra onaylandığında, bu bilgiler üzerinde <b>ek düzenleme yapamazsınız</b>.<br><br>Herhangi bir iletişim veya güncelleme ihtiyacınız olduğunda, <a href="/kullanici-destek-talepleri" target="_blank">destek sayfası</a> üzerinden bizimle iletişime geçebilirsiniz.<br><br>Yüklediğiniz dataset’lere <b>abonelik gerçekleştiğinde</b> ve araştırmacılarla iletişim kurmak istediğinizde, bu bilgileri dataset’i yüklediğiniz sayfadaki <b>liste üzerinden görüntüleyebilirsiniz</b>.<br><br>Veri setiniz <b>canlıya alındığında</b>, tarafınıza <b>otomatik bilgilendirme e-postası</b> gönderilecektir. Ayrıca, dataset ile ilişkili olarak eklediğiniz <b>araştırmacılara da e-posta yoluyla bilgilendirme</b> yapılacaktır.',
        style: 'width: 760px;'
      },
      en: {
        caption: 'Dataset General Information',
        content: '<b>Information:</b> Once your dataset has been reviewed, <b>general adjustments</b> and <b>language checks</b> are performed by the system administration and the dataset is approved, you will <b>no longer be able to make further edits</b>.<br><br>If you require any communication or updates, please contact us via the <a href="/user-support-list" target="_blank">support page</a>.<br><br>When users subscribe to your dataset and when you wish to communicate with researchers, you can view this information in the <b>dataset list</b> on the page where you uploaded your dataset.<br><br>Once your dataset goes <b>live</b>, you will receive an <b>automatic email notification</b>. In addition, any <b>researchers associated with the dataset</b> will also be notified via email.',
        style: 'width: 760px;'
      }
    },

    visiting_researcher_institution_request_text: {
      tr: {
        caption: 'Misafir Araştırmacı Kurum Talebi',
        content: '<b>Açıklama:</b> Dataset’in üretildiği kurum veya üniversite, bu dataset ile ilişkili çalışmalarda <b>dataset abonesinin misafir araştırmacı statüsünde olmasını</b> sözleşme düzeyinde zorunlu tutabilir.<br><br>Bu alanda, ilgili zorunluluğa ait <b>detaylar açıkça belirtilmelidir</b>.<br><br>Örnek: <i>Bu dataset’i kullanmak isteyen araştırmacıların, İstinye Üniversitesi’nde misafir araştırmacı statüsünde olmaları zorunludur. Misafir araştırmacı olarak üretilen makalelerde, yazar kurum bilgileri içerisinde ikinci kurum olarak İstinye Üniversitesi’nin belirtilmesi gerekmektedir.</i>',
        style: 'width: 760px;'
      },
      en: {
        caption: 'Visiting Researcher Institution Requirement',
        content: '<b>Description:</b> The institution or university where the dataset was produced may require dataset subscribers to hold <b>visiting researcher status</b> as part of a contractual obligation when using the dataset.<br><br>This section should clearly describe the <b>specific requirements</b> related to this obligation.<br><br>Example: <i>Researchers wishing to use this dataset must hold visiting researcher status at XYZ University. In any resulting publications, XYZ University must be listed as the second institutional affiliation for the authors.</i>',
        style: 'width: 760px;'
      }
    },
    various_variables: {
      tr: {
        caption: 'Temel Değişkenler ve Açıklamaları',
        content: '<b>Açıklama:</b> Bu bölümde dataset’te kullanılan <b>en önemli değişkenleri</b> ve bunların hangi gruplar altında toplandığını açıklayınız.<br><br><ul style="margin-left:16px;"><li><b>Seçenekli (kategorik) değişkenler</b> için her bir seçeneğin ne anlama geldiğini açıkça belirtiniz.</li><li><b>Sayısal değişkenlerde</b> başlığın ölçüm türünü, birimini veya kapsamını netleştiriniz.</li><li><b>Üretim yöntemi özel bilgi gerektiren değişkenlerde</b>, verinin nasıl elde edildiğini kısaca detaylandırınız.</li></ul><br>Örnek açıklama: <i>EEG sinyallerine ait bant güç ortalamaları Welch yöntemi kullanılarak hesaplanmıştır.</i>',
        style: 'width: 680px;'
      },
      en: {
        caption: 'Key Variables and Descriptions',
        content: '<b>Description:</b> In this section, describe the <b>most important variables</b> used in the dataset and explain how they are grouped.<br><br><ul style="margin-left:16px;"><li>For <b>categorical variables</b>, clearly define what each option represents.</li><li>For <b>numerical variables</b>, ensure the variable name clearly reflects the measurement type, unit, or scope.</li><li>For variables that require methodological clarification, briefly explain <b>how the data were generated or calculated</b>.</li></ul><br>Example: <i>Average power values of EEG frequency bands were calculated using the Welch method.</i>',
        style: 'width: 680px;'
      }
    },

  register_username: {
    tr: {
      caption: 'Kullanıcı Adı',
      content: 'Bu alan sistemdeki <b>tekil kullanıcı adınızı</b> ifade eder.<br><br>• Daha sonra <b>değiştirilemez</b>.<br>• Yalnızca <b>İngilizce karakterler</b> (a–z, 0–9) kullanılmalıdır.<br>• <b>Boşluk</b> ve özel karakter içeremez.<br><br>Kullanıcı adınız profiliniz, giriş işlemleri ve sistem içi referanslarda kullanılacaktır.',
      style: 'width: 520px;'
    },
    en: {
      caption: 'Username',
      content: 'This field represents your <b>unique username</b> in the system.<br><br>• It <b>cannot be changed</b> later.<br>• Only <b>English characters</b> (a–z, 0–9) are allowed.<br>• <b>No spaces</b> or special characters may be used.<br><br>Your username is used for login, profile identification, and system references.',
      style: 'width: 520px;'
    }
  },

  register_user_type: {
    tr: {
      caption: 'Kullanıcı Tipi',
      content: 'Bu alanda kullanıcı tipinizi seçersiniz.<br><br>• <b>Bireysel</b>: Bireysel kullanım için kayıt olan kullanıcılar.<br>• <b>Kurumsal</b>: Kurum, şirket, üniversite veya organizasyon adına işlem yapacak kullanıcılar.<br><br>Seçiminiz faturalama, yetkilendirme ve kurumsal işlemleri etkiler.',
      style: 'width: 520px;'
    },
    en: {
      caption: 'User Type',
      content: 'This field allows you to select your user type.<br><br>• <b>Personnel</b>: Individual researchers, academics, or personal users.<br>• <b>Business</b>: Users acting on behalf of an institution, company, university, or organization.<br><br>Your selection affects billing, authorization, and institutional processes.',
      style: 'width: 520px;'
    }
  },

  register_firstname: {
    tr: {
      caption: 'Ad',
      content: 'Bu alana <b>gerçek adınızı</b> giriniz.<br><br>Bu bilgi; kullanıcı profili, faturalama işlemleri ve resmi yazışmalarda kullanılacaktır.<br>Lütfen kısaltma veya takma ad kullanmayınız.',
      style: 'width: 420px;'
    },
    en: {
      caption: 'First Name',
      content: 'Enter your <b>real first name</b> in this field.<br><br>This information is used for the user profile, billing processes, and official correspondence.<br>Please do not use abbreviations or nicknames.',
      style: 'width: 420px;'
    }
  },

  register_lastname: {
    tr: {
      caption: 'Soyad',
      content: 'Bu alana <b>gerçek soyadınızı</b> giriniz.<br><br>Bu bilgi; kullanıcı profili, faturalama işlemleri ve resmi yazışmalarda kullanılacaktır.<br>Lütfen kısaltma veya takma ad kullanmayınız.',
      style: 'width: 420px;'
    },
    en: {
      caption: 'Last Name',
      content: 'Enter your <b>real last name</b> in this field.<br><br>This information is used for the user profile, billing processes, and official correspondence.<br>Please do not use abbreviations or nicknames.',
      style: 'width: 420px;'
    }
  },


  register_bill_agreement_name: {
    tr: {
      caption: 'Fatura Ünvanı',
      content: 'Bu alan, <b>fatura kesim sürecinde kullanılacak isim bilgisini</b> ifade eder.<br><br>Ad–soyad bilgisi her zaman faturada yer almak zorunda değildir.<br>Fatura, kullanıcı talebine bağlı olarak <b>şirket veya kurum adına</b> düzenlenebilir.',
      style: 'width: 520px;'
    },
    en: {
      caption: 'Billing Name',
      content: 'This field represents the <b>name to be used for invoicing</b>.<br><br>The first and last name is not always required on the invoice.<br>Depending on user preference, the invoice may be issued <b>in the name of a company or institution</b>.',
      style: 'width: 520px;'
    }
  },

register_tax_office: {
  tr: {
    caption: 'Vergi Dairesi',
    content: 'Fatura kesiminin <b>şirket veya kurum adına</b> yapılması durumunda, ilgili <b>vergi dairesi</b> bilgisini bu alanda belirtiniz.',
    style: 'width: 420px;'
  },
  en: {
    caption: 'Tax Office',
    content: 'If the invoice is to be issued <b>on behalf of a company or institution</b>, please specify the relevant <b>tax office</b> in this field.',
    style: 'width: 420px;'
  }
},


bill_settings: {
  tr: {
    caption: 'Fatura Bilgileri',
    content: 'Bu bölüm, <b>bireysel veya kurumsal kullanıcı fark etmeksizin</b> fatura kesimi için doldurulmalıdır.<br><br>• <b>Bireysel kullanıcılar</b> bu alanda ad–soyad bilgilerini tanımlayabilir.<br>• Ülkeye özgü <b>kimlik numaraları</b> vergi numarası alanına girilebilir.<br>• Bireysel kullanıcıların da bazı durumlarda <b>şirket adına fatura</b> oluşturması gerekebilir.<br><br><b>Bu alanlar tanımlanmadığında</b>, sistem tarafından <b>yalnızca kullanıcı adına (isim bazlı)</b> fatura düzenlenebilir.<br><br>Bu nedenle, faturalama senaryonuza uygun olacak şekilde bilgileri eksiksiz doldurunuz.<br><br><b>Sözleşme kapsamındaki fatura adı, adresi ve ilgili bilgiler</b> bu alandan alınacaktır.',
    style: 'width: 650px;'
  },
  en: {
    caption: 'Billing Settings',
    content: 'This section must be completed for invoicing purposes <b>regardless of whether the user is an individual or an institutional user</b>.<br><br>• <b>Individual users</b> may enter their full name in this section.<br>• Country-specific <b>national identification numbers</b> may be entered in the tax number field.<br>• In some cases, individual users may also need to generate an <b>invoice on behalf of a company</b>.<br><br><b>If these fields are not defined</b>, the system will issue an invoice <b>only under the user’s name</b>.<br><br>Please complete this section according to your invoicing scenario.<br><br><b>Invoice name, address, and related contract information</b> will be derived from the details provided here.',
    style: 'width: 650px;'
  }
},

register_bill_tax_number: {
  tr: {
    caption: 'Vergi / Kimlik Numarası',
    content: 'Bu alana fatura kesimi için kullanılacak <b>vergi numarası</b> veya bireysel kullanıcılar için <b>ülkeye özgü kimlik numarası</b> girilmelidir.<br><br>• Kurumsal faturalarda şirketin <b>vergi numarası</b> kullanılmalıdır.<br>• Bireysel faturalarda, ilgili ülkenin <b>resmî kimlik numarası</b> bu alana tanımlanabilir.<br><br>Bu bilgi, fatura ve sözleşme süreçlerinde resmi kayıt olarak kullanılacaktır.',
    style: 'width: 520px;'
  },
  en: {
    caption: 'Tax / Identification Number',
    content: 'Enter the <b>tax number</b> to be used for invoicing, or for individual users, the <b>country-specific identification number</b>.<br><br>• For corporate invoices, the company’s <b>tax identification number</b> must be provided.<br>• For individual invoices, the official <b>national identification number</b> may be entered.<br><br>This information is used as an official reference for invoicing and contractual processes.',
    style: 'width: 520px;'
  }
},

register_bill_address: {
  tr: {
    caption: 'Fatura Adresi',
    content: 'Bu alana <b>fatura kesiminde kullanılacak açık adres bilgisi</b> girilmelidir.<br><br>• Bireysel kullanıcılar kendi ikamet adreslerini yazabilir.<br>• Kurumsal kullanıcılar şirketin <b>resmî fatura adresini</b> belirtmelidir.<br><br>Bu adres bilgisi; fatura, sözleşme ve resmî yazışmalarda esas alınacaktır.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Billing Address',
    content: 'Enter the <b>full address to be used for invoicing</b> in this field.<br><br>• Individual users may provide their residential address.<br>• Corporate users should enter the company’s <b>official billing address</b>.<br><br>This address will be used for invoices, contracts, and official correspondence.',
    style: 'width: 620px;'
  }
},

register_mail: {
  tr: {
    caption: 'E-posta Adresi',
    content: 'Bu alana <b>aktif ve doğru bir e-posta adresi</b> giriniz.<br><br>Sistem, kayıt sürecinde size <b>otomatik bilgilendirme ve onay e-postaları</b> gönderecektir.<br><br>E-posta adresiniz <b>sistem genelinde tekil olarak tanımlanır</b> ve daha sonra <b>değiştirilemez</b>.<br><br>Değiştirme veya sonlanma ihtimali bulunan e-posta adresleri (geçici, kişisel veya kurumsal erişimi sona erebilecek adresler) ile ilerlemeniz durumunda, <b>ilerleyen süreçlerde işlem yapamayabileceğinizi</b> unutmayınız.<br><br><b>Kurumsal e-posta adresleri</b>, özellikle kurumsal abonelikler ve yetkilendirme süreçleri için önerilir.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Email Address',
    content: 'Please enter a <b>valid and active email address</b>.<br><br>The system will send you <b>automatic notification and verification emails</b> during the registration process.<br><br>Your email address is defined as <b>unique across the system</b> and <b>cannot be changed</b> later.<br><br>If you use an email address that may be changed or deactivated in the future (temporary, personal, or expiring institutional emails), you may <b>lose the ability to perform actions on the platform</b>.<br><br><b>Institutional email addresses</b> are strongly recommended, especially for corporate subscriptions and authorization processes.',
    style: 'width: 620px;'
  }
},
projects_excel_file: {
  tr: {
    caption: 'Excel Dosyası (Proje Verisi)',
    content: 'Yüklediğiniz Excel dosyasındaki <b>kolon başlıkları</b> baz alınarak projenin veri kolonları otomatik olarak oluşturulur.<br><br>Bu kolonlar, ilerleyen aşamalarda <b>makale ve rapor çıktıları</b> üretilirken de kullanılacağından; kolon adlarının <b>açık, anlaşılır ve anlamlı</b> olması, sonuç metinlerinin doğruluğu açısından önemlidir.<br><br><b>Kolon adlandırma ve yapı:</b><ul style="margin-left:16px;"><li>Kolon adları <b>tekil (benzersiz)</b> olmalıdır.</li><li>Her kolon, temsil ettiği veriyi net şekilde tanımlamalıdır.</li></ul><br>Sistem, kolonlardaki verileri otomatik olarak analiz ederek <b>veri tipini</b> tahmin eder. Ancak bu tahminler her zaman doğru olmayabilir.<br><br><b>Veri tipi kararları:</b><ul style="margin-left:16px;"><li>Bazen bir veri <b>sayısal gibi görünüp aslında kategorik (select)</b> olabilir.</li><li>Bazen de veri <b>kategorik gibi görünmesine rağmen sayısal analiz</b> gerektirebilir.</li></ul>Bu gibi durumlarda <b>nihai karar veri yükleyiciye aittir</b>.<br><br><b>Sayısal veri tipleri:</b><ul style="margin-left:16px;"><li><b>Integer</b>: Tam sayılar (örn. 1, 25, 100)</li><li><b>Float</b>: Ondalıklı sayılar (örn. 3.14, 12.5)</li></ul><b>Diğer veri tipleri:</b><ul style="margin-left:16px;"><li><b>Text</b>: Analiz edilmesi uygun olmayan, açıklama veya serbest metin içeren veriler için</li><li><b>DateTime</b>: Tarihsel/zamansal veriler için (örn. <i>2025-01-01</i>, <i>2025-01-01 12:45</i>)</li></ul><br><b>Anormal değerler (outlier) yönetimi:</b><br>Sistem, <b>olağan dışı yüksek veya düşük değerleri</b> otomatik olarak tespit edip bildirir.<br><br>Bu değerler:<ul style="margin-left:16px;"><li>Analizden çıkarılmak isteniyorsa karşılarındaki girdi alanı boş bırakılarak kaldırılabilir</li><li>Hedeflenen başka bir değerle değiştirilerek düzenlenebilir</li></ul>Bu işlemler sonrasında veri seti kontrollü şekilde temizlenmiş olur.<br><br><b>Kategorik veri düzeltmeleri:</b><br>Kategorik kolonlarda bazen aynı anlamı taşıyan değerler, farklı karakterler nedeniyle çoğalmış olabilir.<br><br>Örneğin: <i>male</i> ve <i>mmale</i> gibi yanlışlıkla oluşmuş iki farklı tanım bulunabilir.<br><br>Bu durumda düzenleme alanında <i>mmale</i> karşılığı <i>male</i> olarak girildiğinde, sistem <b>tüm mmale değerlerini otomatik olarak male ile düzeltir</b>.<br><br>Veri tiplerinin doğru tanımlanması, analizlerin <b>otomatik, doğru ve tekrarlanabilir</b> şekilde yapılabilmesi için kritik öneme sahiptir.',
    style: 'width: 780px;'
  },
  en: {
    caption: 'Excel File (Project Data)',
    content: 'The <b>column headers</b> in the uploaded Excel file are used to automatically generate the project’s data columns.<br><br>Since these columns are also used to produce <b>article and report outputs</b>, column names must be <b>clear, descriptive, and meaningful</b> to ensure accurate results.<br><br><b>Column naming and structure:</b><ul style="margin-left:16px;"><li>Column names must be <b>unique</b>.</li><li>Each column should clearly describe the data it represents.</li></ul><br>The system automatically analyzes column values to infer <b>data types</b>. However, this inference may not always be correct.<br><br><b>Data type decisions:</b><ul style="margin-left:16px;"><li>A value may <b>appear numeric but actually be categorical (select)</b>.</li><li>A value may <b>look categorical but require numeric analysis</b>.</li></ul>In such cases, the <b>final decision belongs to the data uploader</b>.<br><br><b>Numeric data types:</b><ul style="margin-left:16px;"><li><b>Integer</b>: Whole numbers (e.g. 1, 25, 100)</li><li><b>Float</b>: Decimal numbers (e.g. 3.14, 12.5)</li></ul><b>Other data types:</b><ul style="margin-left:16px;"><li><b>Text</b>: For free-text or non-analytical data</li><li><b>DateTime</b>: For temporal data (e.g. <i>2025-01-01</i>, <i>2025-01-01 12:45</i>)</li></ul><br><b>Outlier management:</b><br>The system automatically detects <b>abnormally high or low values</b> and reports them.<br><br>These values can be:<ul style="margin-left:16px;"><li>Excluded from analysis by clearing the corresponding input field</li><li>Replaced with a target value to correct the dataset</li></ul>This allows controlled and transparent data cleaning.<br><br><b>Categorical data corrections:</b><br>In categorical columns, the same category may appear multiple times due to character inconsistencies.<br><br>For example, <i>male</i> and <i>mmale</i> may exist due to an Excel entry error.<br><br>When <i>mmale</i> is corrected to <i>male</i>, the system will <b>automatically fix all mmale values</b> accordingly.<br><br>Correct data type definitions are critical for enabling <b>fully automated, accurate, and reproducible analyses</b>.',
    style: 'width: 780px;'
  }
},

project_column_create: {
  tr: {
    caption: 'Kolon Oluşturma',
    content: 'Kolon üretimi sürecinde <b>iki farklı kolon tipi</b> kullanılabilir:<br><br><b>1) Manuel Kolon</b><br><b>2) Veritabanı Kolonu (WDM)</b><br><br><b>Manuel kolon:</b><ul style="margin-left:16px;"><li>Manuel Excel yükleme ile oluşturulan projelerde <b>yalnızca manuel kolonlar</b> tanımlanabilir.</li><li>Bu kolonlarda, mevcut kolonlardan elde edilen veriler kullanılarak <b>matematiksel fonksiyonlar</b>, <b>kural tabanlı algoritmalar</b> ve <b>NLP / AI modelleri</b> çalıştırılabilir.</li><li>Üretilen çıktılar hücre bazında hesaplanarak ilgili kolona yazılır.</li></ul><br><b>Veritabanı kolonu (WDM):</b><ul style="margin-left:16px;"><li>Veritabanına entegre sistemlerde kullanılır.</li><li>Bu kolonlar, doğrudan <b>veritabanındaki alanlara</b> bağlanan katmanlarla ilişkilidir.</li><li>Veri, manuel giriş yerine <b>entegre sistemlerden otomatik olarak</b> alınır.</li></ul><br>Manuel Excel projelerinde veritabanı kolonu tanımlanamaz. Veritabanı kolonları yalnızca <b>entegrasyon destekli projelerde</b> aktif olarak kullanılabilir.',
    style: 'width: 760px;'
  },
  en: {
    caption: 'Column Creation',
    content: 'During column creation, <b>two different column types</b> can be used:<br><br><b>1) Manual Column</b><br><b>2) Database Column (WDM)</b><br><br><b>Manual columns:</b><ul style="margin-left:16px;"><li>In projects created via manual Excel upload, <b>only manual columns</b> can be defined.</li><li>These columns allow outputs to be generated by applying <b>mathematical functions</b>, <b>rule-based algorithms</b>, and <b>NLP / AI models</b> to existing columns.</li><li>The generated results are calculated at the cell level and written into the column.</li></ul><br><b>Database columns (WDM):</b><ul style="margin-left:16px;"><li>Used in systems integrated with a database.</li><li>These columns are linked to layers that directly access <b>database fields</b>.</li><li>Data is retrieved <b>automatically from integrated systems</b>, not entered manually.</li></ul><br>Database columns cannot be defined in manual Excel projects. They are available only in <b>integration-enabled projects</b>.',
    style: 'width: 760px;'
  }
},

project_scope: {
  tr: {
    caption: 'Proje Kapsamı',
    content: 'Bu alan, projelerin <b>kapsamlarına göre gruplandırılması</b> için kullanılır.<br><br>Aynı kapsam altında tanımlanan projeler;<ul style="margin-left:16px;"><li>Liste ekranlarında <b>birlikte</b> görüntülenir,</li><li>Projelerin daha <b>düzenli ve okunabilir</b> şekilde yönetilmesini sağlar,</li><li>Benzer amaçlı çalışmaların <b>tek bir grup altında</b> toplanmasına olanak tanır.</li></ul><br>Proje kapsamı, projelerin içeriğini veya analizlerini etkilemez; yalnızca <b>görsel ve yönetsel organizasyon</b> amacıyla kullanılır.',
    style: 'width: 640px;'
  },
  en: {
    caption: 'Project Scope',
    content: 'This field is used to <b>group projects by scope</b>.<br><br>Projects defined under the same scope:<ul style="margin-left:16px;"><li>Are displayed <b>together</b> in project lists,</li><li>Improve <b>organizational clarity and navigation</b>,</li><li>Allow related studies to be <b>managed under a single group</b>.</li></ul><br>The project scope does not affect project content or analyses; it is used solely for <b>visual and administrative organization</b>.',
    style: 'width: 640px;'
  }
},

project_case_limit_count: {
  tr: {
    caption: 'Minimum Veri Sayısı',
    content: 'Bu alan, projeye dahil edilmesi gereken <b>minimum veri (olgu) sayısını</b> belirtir.<br><br>Belirtilen bu değer, projede kullanılacak verinin <b>alt sınırını</b> tanımlar.<br><br>Sistem, bu sayı veya daha fazla verinin hazırlanmasını ve analizlere dahil edilmesini sağlar.<br><br>Bu alan, özellikle istatistiksel analizlerin ve modelleme süreçlerinin <b>yeterli veri hacmi</b> ile çalışmasını güvence altına almak amacıyla kullanılır.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Minimum Case Count',
    content: 'This field specifies the <b>minimum number of data cases</b> to be included in the project.<br><br>The defined value represents the <b>lower limit</b> of data required for analysis.<br><br>The system ensures that this number, or a higher amount of data, is prepared and included in the analyses.<br><br>This setting is used to ensure that statistical analyses and modeling processes operate with a <b>sufficient data volume</b>.',
    style: 'width: 620px;'
  }
},

project_main_layer: {
  tr: {
    caption: 'Ana Katman',
    content: 'Bu alanda, projenin <b>ana katmanı</b> seçilir.<br><br>Ana katman, projedeki <b>her bir satırın hangi varlığa ait tekil bir veriyi temsil ettiğini</b> tanımlar.<br><br><b>Örnek ana katman senaryoları:</b><ul style="margin-left:16px;"><li><b>Hasta katmanı</b> seçildiğinde, her satır <b>tek bir hastayı</b> temsil eder.</li><li><b>Protokol katmanı</b> seçildiğinde, her satır <b>tekil bir protokolü</b> temsil eder.</li><li><b>Laboratuvar katmanı</b> seçildiğinde, her satır <b>tekil bir laboratuvar kaydını</b> temsil eder.</li></ul><br><b>Çoklama (çoğullama) mantığı:</b><br>Ana katman seçimi, diğer ilişkili kolonların <b>nasıl çoğaltılacağını veya tekilleştirileceğini</b> belirler.<br><br>Örneğin <b>Laboratuvar katmanı</b> ana katman olarak seçildiğinde;<ul style="margin-left:16px;"><li>Her satır <b>tekil bir laboratuvar kaydı</b> olur,</li><li><b>Hasta ID</b> bilgisi bir kolona tanımlanırsa, aynı hastaya ait birden fazla laboratuvar kaydı nedeniyle <b>hasta ID değerleri satırlar boyunca tekrarlanır</b>,</li><li>Buna karşılık <b>laboratuvar ID</b> değerleri her satırda <b>tekil</b> kalır.</li></ul><br>Ana katman seçimi, veri setinin <b>satır mantığını</b>, <b>ilişkisel yapısını</b> ve analizlerin <b>hangi düzeyde</b> (hasta, protokol, laboratuvar vb.) yapılacağını belirleyen <b>temel yapısal karardır</b>.',
    style: 'width: 760px;'
  },
  en: {
    caption: 'Main Layer',
    content: 'This field defines the <b>main layer</b> of the project.<br><br>The main layer specifies <b>which entity each row represents as a unique record</b>.<br><br><b>Main layer examples:</b><ul style="margin-left:16px;"><li>When the <b>Patient layer</b> is selected, each row represents <b>a single patient</b>.</li><li>When the <b>Protocol layer</b> is selected, each row represents <b>a unique protocol</b>.</li><li>When the <b>Laboratory layer</b> is selected, each row represents <b>a unique laboratory record</b>.</li></ul><br><b>Row multiplication logic:</b><br>The selected main layer determines <b>how related columns are replicated or kept unique</b>.<br><br>For example, when the <b>Laboratory layer</b> is selected as the main layer:<ul style="margin-left:16px;"><li>Each row corresponds to <b>a single laboratory record</b>,</li><li>If a <b>Patient ID</b> column is included, the same patient ID may <b>repeat across multiple rows</b> due to multiple laboratory records,</li><li>In contrast, the <b>laboratory ID</b> remains <b>unique per row</b>.</li></ul><br>The main layer selection is a <b>core structural decision</b> that defines the dataset’s row logic, relational behavior, and the <b>level at which analyses are performed</b> (patient, protocol, laboratory, etc.).',
    style: 'width: 760px;'
  }
},

project_location: {
  tr: {
    caption: 'Proje Lokasyonu',
    content: 'Bu alanda, verinin bağlı olduğu <b>lokasyon</b> ve bu lokasyonla ilişkili <b>sunucular</b> seçilir.<br><br>Seçilen proje lokasyonu;<ul style="margin-left:16px;"><li>Verinin hangi <b>fiziksel veya mantıksal ortamdan</b> alınacağını,</li><li>Hangi <b>sunucu ve veritabanlarına</b> bağlantı kurulacağını,</li><li>Veri hazırlama ve entegrasyon süreçlerinin <b>hangi altyapı üzerinden</b> yürütüleceğini</li></ul>belirler.<br><br>Bu seçim doğrultusunda sistem, ilgili veritabanlarına bağlanarak verileri otomatik olarak hazırlar ve projeye dahil eder.',
    style: 'width: 660px;'
  },
  en: {
    caption: 'Project Location',
    content: 'This field is used to select the <b>location</b> to which the data belongs, along with the <b>associated servers</b>.<br><br>The selected project location determines:<ul style="margin-left:16px;"><li>From which <b>physical or logical environment</b> the data is retrieved,</li><li>Which <b>servers and databases</b> are connected,</li><li>Which infrastructure is used for <b>data preparation and integration</b>.</li></ul><br>Based on this selection, the system connects to the relevant databases and automatically prepares the data for the project.',
    style: 'width: 660px;'
  }
},

project_main_rule: {
  tr: {
    caption: 'Proje Ana Kuralı',
    content: 'Bu alan, projeye dahil edilmesini istediğiniz veriler için <b>ana satır filtresini</b> tanımlar.<br><br><b>Önemli:</b> Bu kural <u>kolon seçimi anlamına gelmez</u>. Yalnızca <b>hangi satırların</b> projeye dahil edileceğini belirler.<br><br>İşleyiş şu şekildedir:<ul style="margin-left:16px;"><li>Öncelikle <b>ana kurala uygun satırlar</b> filtrelenerek alınır,</li><li>Daha sonra bu satırlar üzerinde, <b>kolon listesi bölümünde tanımlanan kolon kuralları</b> uygulanır,</li><li>Hedef kolonlara ait veriler, yalnızca bu kolon kurallarına göre üretilir veya getirilir.</li></ul><br>Bu yapı sayesinde, satır bazlı filtreleme ile kolon bazlı kurallar birbirinden ayrılır ve daha kontrollü, esnek bir proje kurgusu sağlanır.',
    style: 'width: 680px;'
  },
  en: {
    caption: 'Project Main Rule',
    content: 'This field defines the <b>main row-level filter</b> for determining which records are included in the project.<br><br><b>Important:</b> This rule <u>does not define column selection</u>. It only specifies <b>which rows</b> are included.<br><br>The workflow is as follows:<ul style="margin-left:16px;"><li>First, rows that match the <b>main rule</b> are filtered and selected,</li><li>Then, <b>column rules defined in the column list section</b> are applied to these rows,</li><li>Target column values are retrieved or generated strictly according to the column rules.</li></ul><br>This separation between row-level filtering and column-level rules enables a more controlled, flexible, and scalable project design.',
    style: 'width: 680px;'
  }
},

projects_calculate_case_count: {
  tr: {
    caption: 'Vaka Sayısı Hesaplama',
    content: 'Bu alan, tanımlanan <b>ana kurala uygun vaka (satır) adedini</b> hesaplamak için kullanılır.<br><br><b>Önemli:</b> Bu işlem <u>veri getirmez</u> ve projeye herhangi bir satır eklemez.<br><br>Yalnızca:<ul style="margin-left:16px;"><li>Ana kuralın kaç vakayı kapsadığını görmek,</li><li>Tanımlanan filtrelerin veri hacmine etkisini önceden değerlendirmek,</li><li>Proje için yeterli veri olup olmadığını kontrol etmek</li></ul> amacıyla kullanılır.<br><br>Bu sayede veri çekme ve kolon üretim adımlarına geçmeden önce, proje kapsamı güvenli şekilde doğrulanabilir.',
    style: 'width: 640px;'
  },
  en: {
    caption: 'Calculate Case Count',
    content: 'This field calculates the <b>number of cases (rows)</b> that match the defined <b>main rule</b>.<br><br><b>Important:</b> This operation <u>does not retrieve any data</u> and does not add rows to the project.<br><br>It is used only to:<ul style="margin-left:16px;"><li>Check how many cases are covered by the main rule,</li><li>Evaluate the impact of filters on data volume in advance,</li><li>Verify whether sufficient data exists for the project</li></ul> before proceeding to data retrieval and column generation steps.',
    style: 'width: 640px;'
  }
},

projects_variables: {
  tr: {
    caption: 'Değişkenler (Kolon Listesi)',
    content: 'Bu alanda projeye ait <b>tüm kolonlar (değişkenler)</b> listelenir.<br><br>Her değişkenin sağ tarafında yer alan <b>grafik başlığı altındaki ikonlar</b> kullanılarak değişkenler analizlere dahil edilebilir.<br><br><b>İstatistik Analizleri:</b><ul style="margin-left:16px;"><li><b>Seçilen Değişkenlerle Tanımlayıcı</b> seçilirse, her bir değişken için <u>yalnızca kendi tanımlayıcı istatistikleri</u> üretilir.</li><li><b>Seçilen Değişkenlerle Kombinasyonlar Üreterek Karşılaştırmalı</b> seçilirse, sistem seçilen değişkenleri <u>ikili kombinasyonlar halinde</u> otomatik gruplar ve karşılaştırmalı analizler gerçekleştirir.</li><li>Bu karşılaştırmalarda sistem; <b>kategorik & numerik</b>, <b>kategorik & kategorik</b> veya <b>numerik & numerik</b> olma durumuna göre <u>uygun istatistiksel testi otomatik belirler</u>.</li><li>Sayısal veriler için önce <b>dağılım analizi</b> yapılır ve standart istatistik kurallarına göre uygun test seçilir.</li></ul><br><b>Çoklu Girdi – Tek Çıktı Karşılaştırması:</b><br>Bu seçenek tercih edilirse, değişken listesinden seçilen tüm girdiler, <b>çıktı olarak belirlenen tek değişken</b> ile karşılaştırılır. Bu durumda otomatik ikili kombinasyon üretilmez; tüm girdiler doğrudan hedef değişken ile analiz edilir.<br><br><b>Makine Öğrenmesi:</b><br>Makine öğrenmesi analizlerinde <b>girdi değişkenleri</b> bu listeden seçilir. <b>Çıktı değişkeni</b> ise makine öğrenmesi bölümünde ayrıca tanımlanır.<br><br><b>Dataset (Veri Listeleme):</b><br>Değişkenlerin yanındaki <b>kural alanları</b> doldurulursa, yalnızca bu kurallara uyan <u>filtreli veriler</u> listelenir. Herhangi bir kural tanımlanmazsa, tüm veri <u>filtresiz</u> olarak görüntülenir.',
    style: 'width: 720px;'
  },
  en: {
    caption: 'Variables (Column List)',
    content: 'This section displays <b>all columns (variables)</b> defined in the project.<br><br>Variables can be selected for analysis by clicking the <b>icons under the chart header</b> next to each variable.<br><br><b>Statistical Analyses:</b><ul style="margin-left:16px;"><li>If <b>Descriptive with Selected Variables</b> is chosen, only the <u>descriptive statistics of each selected variable</u> are generated.</li><li>If <b>Comparative by Generating Variable Combinations</b> is selected, the system automatically creates <u>pairwise combinations</u> of the selected variables and performs comparative analyses.</li><li>The system automatically determines the appropriate statistical test based on whether the combination is <b>categorical & numeric</b>, <b>categorical & categorical</b>, or <b>numeric & numeric</b>.</li><li>For numeric variables, a <b>distribution analysis</b> is performed first, and the test is selected according to standardized statistical rules.</li></ul><br><b>Multiple Inputs – Single Output Comparison:</b><br>When this option is selected, all input variables chosen from the list are compared directly with the <b>single output variable</b>. In this case, automatic pairwise combinations are not generated.<br><br><b>Machine Learning:</b><br>In machine learning analyses, <b>input variables</b> are selected from this list. The <b>output variable</b> is defined separately in the machine learning section.<br><br><b>Dataset (Data Listing):</b><br>If rules are defined in the <b>filter fields</b> next to variables, only data matching these rules will be listed. If no rules are specified, the entire dataset is displayed <u>without filtering</u>.',
    style: 'width: 720px;'
  }
},

projects_variables_operator: {
  tr: {
    caption: 'Değişken Operatörü',
    content: '<b>Açıklama:</b> Bu alan, değişkenler üzerinde <b>filtre tanımlamak</b> için kullanılır.<br><br>Seçilen operatörler (>, <, =, ≠, içerir, aralık vb.) ile oluşturulan kurallar doğrultusunda <u>yalnızca filtreye uyan veriler</u> analiz sürecine dahil edilir.<br><br>Bu sayede analizler, tüm veri yerine <b>hedeflenen alt veri grubu</b> üzerinde gerçekleştirilmiş olur. Tanımlanan operatör filtreleri hem istatistiksel analizlerde hem de makine öğrenmesi süreçlerinde geçerlidir.',
    style: 'width: 600px;'
  },
  en: {
    caption: 'Variable Operator',
    content: '<b>Description:</b> This field is used to <b>define filters</b> on variables.<br><br>When filters are created using operators (>, <, =, ≠, contains, range, etc.), <u>only the data matching these conditions</u> will be included in the analysis.<br><br>This allows analyses to be performed on a <b>targeted subset of data</b> rather than the entire dataset. Defined operator filters apply to both statistical analyses and machine learning processes.',
    style: 'width: 600px;'
  }
},

projects_variables_filter: {
  tr: {
    caption: 'Filtre Değeri',
    content: '<b>Açıklama:</b> Bu alan, seçilen operatör ile ilişkili <b>karşılaştırma değerinin</b> girildiği bölümdür.<br><br>Örneğin;<ul style="margin-left:16px;"><li><b>&gt; 50</b> filtresi için <b>50</b> değeri buraya yazılır.</li><li><b>Aralık</b> operatöründe alt ve üst sınır değerleri burada tanımlanır.</li><li><b>İçerir / eşittir</b> gibi operatörlerde karşılaştırılacak metin veya kategori değeri girilir.</li></ul><br>Bu alana girilen değerler ile operatör birlikte değerlendirilerek <b>filtreye uyan satırlar</b> analiz sürecine dahil edilir.',
    style: 'width: 600px;'
  },
  en: {
    caption: 'Filter Value',
    content: '<b>Description:</b> This field is used to enter the <b>comparison value</b> associated with the selected operator.<br><br>For example:<ul style="margin-left:16px;"><li>For a <b>&gt; 50</b> filter, the value <b>50</b> is entered here.</li><li>For <b>range</b> operators, lower and upper boundary values are defined in this field.</li><li>For operators such as <b>contains / equals</b>, the text or category value to compare is entered.</li></ul><br>The operator and the entered value are evaluated together to include only the <b>rows matching the filter</b> in the analysis.',
    style: 'width: 600px;'
  }
},

projects_variables_selection: {
  tr: {
    caption: 'Değişken Seçimi',
    content: '<b>Açıklama:</b> Bu alanda, analizlerde kullanılacak <b>değişkenler seçilir</b>.<br><br>Bir değişken seçildiğinde, ilgili değişkenin sağında <b>grafik ikonu</b> görünür.<br><br>Seçilen değişkenler; istatistiksel analizler, makine öğrenmesi modelleri ve veri görselleştirme adımlarında kullanılmak üzere aktif hale getirilir.<br><br>Hiçbir değişken seçilmediğinde analiz başlatılamaz.',
    style: 'width: 560px;'
  },
  en: {
    caption: 'Variable Selection',
    content: '<b>Description:</b> This field is used to <b>select variables</b> that will be included in analyses.<br><br>When a variable is selected, a <b>graph icon</b> appears next to it.<br><br>Selected variables become active for statistical analyses, machine learning models, and data visualization steps.<br><br>If no variable is selected, analyses cannot be initiated.',
    style: 'width: 560px;'
  }
},

projects_graph_mode: {
  tr: {
    caption: 'Grafik Modu',
    content: '<b>Açıklama:</b> Bu modda, seçilen değişkenler <b>çok boyutlu olarak gruplanır</b> ve sonuçlar <b>sayısal özet çıktılar</b> şeklinde sunulur.<br><br>Örneğin; <b>cinsiyet</b> ve <b>kurum</b> değişkenleri seçildiğinde, sistem her bir cinsiyet grubu (erkek / kadın) için ilgili kurumlarda bulunan kişi sayılarını ayrı ayrı hesaplar ve raporlar.<br><br>Bu yapı, özellikle <b>raporlama amaçlı oluşturulan datasetlerde</b> ve özet tabloların üretilmesinde kullanılır.',
    style: 'width: 640px;'
  },
  en: {
    caption: 'Graph Mode',
    content: '<b>Description:</b> In this mode, selected variables are <b>grouped in a multidimensional manner</b>, and results are presented as <b>numerical summary outputs</b>.<br><br>For example, when <b>gender</b> and <b>institution</b> are selected, the system calculates and reports the number of individuals in each institution separately for each gender group (male / female).<br><br>This mode is primarily used for <b>report-oriented datasets</b> and generating summary tables.',
    style: 'width: 640px;'
  }
},

projects_dataset_filter: {
  tr: {
    caption: 'Dataset Filtre Sonucu',
    content: '<b>Açıklama:</b> Bu alanda, tanımlanan <b>dataset filtreleri</b> sonucunda elde edilen satırlar listelenir.<br><br>Eğer herhangi bir filtre tanımlanmamışsa, sistem <b>tüm veriyi filtresiz olarak</b> görüntüler.<br><br>Filtreleme işlemleri, değişken bazlı operatör ve değer seçimlerine göre gerçekleştirilir ve analizler yalnızca bu filtrelenmiş veri üzerinden yapılır.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Dataset Filter Result',
    content: '<b>Description:</b> This section displays the rows obtained as a result of the applied <b>dataset filters</b>.<br><br>If no filter is defined, the system lists <b>all data without filtering</b>.<br><br>Filtering is performed based on variable-level operators and values, and analyses are conducted only on the filtered dataset.',
    style: 'width: 620px;'
  }
},

projects_statistics_methods: {
  tr: {
    caption: 'İstatistik Analiz Metodları',
    content: '<b>İstatistik Analizleri:</b><ul style="margin-left:16px;"><li><b>Seçilen Değişkenlerle Tanımlayıcı</b> seçilirse, her bir değişken için <u>yalnızca kendi tanımlayıcı istatistikleri</u> üretilir.</li><li><b>Seçilen Değişkenlerle Kombinasyonlar Üreterek Karşılaştırmalı</b> seçilirse, sistem seçilen değişkenleri <u>ikili kombinasyonlar halinde</u> otomatik gruplar ve karşılaştırmalı analizler gerçekleştirir.</li><li>Bu karşılaştırmalarda sistem; <b>kategorik &amp; numerik</b>, <b>kategorik &amp; kategorik</b> veya <b>numerik &amp; numerik</b> olma durumuna göre <u>uygun istatistiksel testi otomatik belirler</u>.</li><li>Sayısal veriler için önce <b>dağılım analizi</b> yapılır ve standart istatistik kurallarına göre uygun test seçilir.</li></ul><br><b>Çoklu Girdi – Tek Çıktı Karşılaştırması:</b><br>Bu seçenek tercih edilirse, değişken listesinden seçilen tüm girdiler, <b>çıktı olarak belirlenen tek değişken</b> ile karşılaştırılır. Bu durumda otomatik ikili kombinasyon üretilmez; tüm girdiler doğrudan hedef değişken ile analiz edilir.',
    style: 'width: 720px;'
  },
  en: {
    caption: 'Statistical Analysis Methods',
    content: '<b>Statistical Analyses:</b><ul style="margin-left:16px;"><li>If <b>Descriptive Statistics with Selected Variables</b> is selected, <u>only descriptive statistics</u> for each variable are generated.</li><li>If <b>Comparative Analysis by Generating Variable Combinations</b> is selected, the system automatically groups selected variables into <u>pairwise combinations</u> and performs comparative analyses.</li><li>For these comparisons, the system automatically determines the <u>appropriate statistical test</u> based on whether the variable combinations are <b>categorical &amp; numerical</b>, <b>categorical &amp; categorical</b>, or <b>numerical &amp; numerical</b>.</li><li>For numerical data, a <b>distribution analysis</b> is first performed, and the appropriate test is selected according to standard statistical rules.</li></ul><br><b>Multiple Input – Single Output Comparison:</b><br>If this option is selected, all input variables chosen from the variable list are compared against a <b>single target output variable</b>. In this case, no automatic pairwise combinations are generated; all inputs are analyzed directly with the target variable.',
    style: 'width: 720px;'
  }
},

projects_old_results: {
  tr: {
    caption: 'Önceki Analiz Sonuçları',
    content: '<b>Açıklama:</b> Bu alanda daha önce <b>tetiklenmiş ve tamamlanmış analizler</b> sistem tarafından otomatik olarak kaydedilir.<br><br>Kaydedilen analizler daha sonra bu bölümden tekrar açılarak <b>analiz çıktıları yeniden görüntülenebilir</b>.<br><br>Bu sayede aynı analizlerin tekrar çalıştırılmasına gerek kalmadan geçmiş sonuçlara hızlıca erişim sağlanır.',
    style: 'width: 600px;'
  },
  en: {
    caption: 'Previous Analysis Results',
    content: '<b>Description:</b> This section stores <b>previously triggered and completed analyses</b> automatically.<br><br>Saved analyses can be reopened from this area to <b>review analysis outputs again</b> without rerunning the analysis.<br><br>This allows quick access to historical results and ensures reproducibility.',
    style: 'width: 600px;'
  }
},

projects_param_type_text_analyze: {
  tr: {
    caption: 'Metin Tipi Parametre Analizi',
    content: '<b>Açıklama:</b> Parametre tipi <b>text (metin)</b> olarak tanımlandığında ve analizlerde kullanılmak istendiğinde, bu parametrenin <b>kategorik</b> mi yoksa <b>numerik</b> mi olarak ele alınacağının kullanıcı tarafından belirtilmesi gerekir.<br><br>Sistem diğer veri tiplerinde bu bilgiyi otomatik olarak bilir:<ul style="margin-left:16px;"><li><b>select:</b> kategorik</li><li><b>integer:</b> numerik</li><li><b>float:</b> numerik</li></ul><br>Bu nedenle yalnızca <b>text</b> tipindeki parametreler için ek bir seçim yapılması zorunludur.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Text Parameter Analysis Type',
    content: '<b>Description:</b> When a parameter is defined as <b>text</b> and intended to be used in analyses, the user must specify whether it should be treated as <b>categorical</b> or <b>numerical</b>.<br><br>The system automatically knows this information for other data types:<ul style="margin-left:16px;"><li><b>select:</b> categorical</li><li><b>integer:</b> numerical</li><li><b>float:</b> numerical</li></ul><br>Therefore, an additional selection is required only for parameters of type <b>text</b>.',
    style: 'width: 620px;'
  }
},


project_analyze_cross_columns_by_two_grouping: {
  tr: {
    caption: 'İkili Gruplama ile Çapraz Analiz',
    content: '<b>Açıklama:</b> Bu alanda <b>Evet</b> veya <b>Hayır</b> seçenekleri kullanılarak analiz davranışı belirlenir.<br><br>\
<b>Evet</b> olarak seçildiğinde sistem, seçilen değişkenlerin sahip olduğu <b>seçenekler (kategoriler)</b> arasında <b>ikili seçenek kombinasyonları</b> oluşturarak detaylı karşılaştırmalı analizler gerçekleştirir.<br><br>\
Bir değişkenin ikiden fazla seçeneğe sahip olması durumunda, sistem bu seçenekleri <b>2’li kombinasyonlar</b> halinde otomatik olarak eşleştirir ve her bir seçenek çifti için ayrı analiz çıktıları üretir.<br><br>\
Örneğin, <b>3 farklı seçeneğe</b> sahip tek bir değişken seçilmişse, sistem bu seçenekleri ikili olarak eşleştirerek <b>3 ayrı seçenek kombinasyonu analizi</b> gerçekleştirir.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Cross Analysis with Pairwise Grouping',
    content: '<b>Description:</b> In this section, the analysis behavior is determined by selecting <b>Yes</b> or <b>No</b>.<br><br>When <b>Yes</b> is selected, the system performs detailed comparative analyses by generating <b>pairwise combinations of options (categories)</b> within the selected variable(s).<br><br>If a variable contains more than two options, the system automatically pairs these options into <b>two-by-two combinations</b> and produces separate analytical outputs for each option pair.<br><br>For example, if a single variable with <b>three distinct options</b> is selected, the system generates <b>three separate option-combination analyses</b> by evaluating all possible pairwise option comparisons.',
    style: 'width: 620px;'
  }
},

projects_machine_learning_output: {
  tr: {
    caption: 'Makine Öğrenmesi Çıktı Değişkeni',
    content: '<b>Önemli:</b> Anlamlı bulunan makine öğrenmesi modellerinin <b>WAI şablonu</b> ile web uygulamasına entegre edilerek çalıştırılması isteniyorsa, lütfen <b>destek bölümü</b> üzerinden iletişime geçiniz.<br><br><b>Açıklama:</b> Bu alanda <b>tahmin edilmesi istenen çıktı parametresi</b> seçilir.<br><br>Seçilen tüm değişkenler kullanılarak, bu çıktı değişkenini tahmin etmeye yönelik <b>makine öğrenmesi modelleri</b> otomatik olarak üretilir.<br><br>Sistem; değişkenlerin <b>kategorik veya numerik</b> olma durumlarını dikkate alarak <b>hangi makine öğrenmesi algoritmalarının uygun olduğuna</b> kendisi karar verir ve tüm uygun modelleri uygular.<br><br>Uygulanan modeller, <b>doğruluk oranı en yüksekten en düşüğe</b> doğru sıralanarak tablo halinde sunulur.<br><br>Makine öğrenmesi eğitiminde, ilgili algoritmaların <b>varsayılan (default) parametreleri</b> kullanılır. Bu alanın amacı, veri seti için <b>hangi modelin daha uygun olduğunu görmek</b> veya <b>anlamlı bir model kurulup kurulamayacağını değerlendirmektir</b>.<br><br>Bu çıktılar <b>akademik ve ön değerlendirme amaçlarıyla</b> kullanılabilir; ancak <b>optimize edilmiş, üretim ortamına alınacak bir makine öğrenmesi modeli</b> bu alandan doğrudan oluşturulmaz.',
    style: 'width: 740px;'
  },
  en: {
    caption: 'Machine Learning Output Variable',
    content: '<b>Important:</b> If you would like statistically meaningful machine learning models to be integrated into a web application using the <b>WAI template</b>, please contact us through the <b>support section</b>.<br><br><b>Description:</b> This field is used to select the <b>target output variable</b> to be predicted.<br><br>Using all selected variables, the system automatically generates <b>machine learning models</b> to predict the chosen output variable.<br><br>The system determines which algorithms are appropriate by considering whether variables are <b>categorical or numerical</b>, and applies all suitable models automatically.<br><br>The resulting models are presented in a table, <b>sorted from highest to lowest accuracy</b>.<br><br>Model training is performed using the <b>default parameters</b> of each algorithm. The purpose of this section is to evaluate <b>model suitability</b> and determine whether a meaningful predictive model can be established for the dataset.<br><br>These outputs may be used for <b>academic and preliminary evaluation purposes</b>; however, this section does not directly generate <b>optimized, production-ready machine learning models</b>.',
    style: 'width: 740px;'
  }
},

projects_machine_learning_true_option: {
  tr: {
    caption: 'Makine Öğrenmesi Doğru (True) Değeri',
    content: '<b>Açıklama:</b> Makine öğrenmesi modelleri eğitilirken, özellikle <b>lojistik regresyon</b> gibi sınıflandırma algoritmalarında çıktı değişkeni genellikle <b>0</b> ve <b>1</b> değerlerinden oluşur.<br><br>Bu modellerde <b>1</b> değeri <u>doğru (true) sınıf</u> olarak kabul edilerek analizler gerçekleştirilir.<br><br>Bu alanda, seçenekler arasından <b>hangi değerin asıl doğru (true) çıktı olarak kabul edileceği</b> belirtilir. Sistem, doğruluk (accuracy) hesaplamasını ve model eğitimini bu seçime göre yapar.<br><br>Bu ayar, özellikle çıktı değişkeninin kategorik olduğu ve sınıflar arasında <b>anlamsal bir öncelik</b> bulunduğu durumlarda doğru değerlendirme yapılabilmesi için kritiktir.',
    style: 'width: 700px;'
  },
  en: {
    caption: 'Machine Learning True (Positive) Class',
    content: '<b>Description:</b> During machine learning model training, especially for classification algorithms such as <b>logistic regression</b>, the output variable typically consists of <b>0</b> and <b>1</b> values.<br><br>In these models, the value <b>1</b> is treated as the <u>true (positive) class</u> by default.<br><br>This field specifies <b>which option should be considered as the true (positive) output</b>. The system calculates accuracy metrics and trains the model according to this selection.<br><br>This setting is particularly important when the output variable is categorical and when there is a <b>semantic priority</b> between classes to ensure correct model evaluation.',
    style: 'width: 700px;'
  }
},

projects_logistic_regression_true_option: {
  tr: {
    caption: 'Lojistik Regresyon Doğru (True) Sınıf Seçimi',
    content: '<b>Açıklama:</b> Lojistik regresyon analizlerinde, tahmin edilmek istenen <b>hedef (çıktı) değişkeninin</b> doğru şekilde tanımlanması sonuçların daha anlaşılır ve klinik olarak daha anlamlı yorumlanmasını sağlar.<br><br>Bu alanda, hangi seçeneğin <b>pozitif / true sınıf</b> olarak kabul edileceği belirlenir.<br><br>Sistem; olasılık hesaplamalarını, odds ratio yönünü, performans metriklerini ve model çıktılarının yorumlanmasını bu seçime göre gerçekleştirir.<br><br>Özellikle hastalık varlığı, mortalite, komplikasyon gelişimi veya belirli bir klinik sonlanımın tahmin edildiği çalışmalarda doğru hedef sınıfın seçilmesi kritik önem taşır.',
    style: 'width: 700px;'
  },
  en: {
    caption: 'Logistic Regression True (Positive) Class Selection',
    content: '<b>Description:</b> In logistic regression analyses, correctly defining the <b>target (output) variable</b> helps ensure that model results are more interpretable and clinically meaningful.<br><br>This field specifies which option should be considered the <b>positive / true class</b>.<br><br>The system performs probability estimation, odds ratio direction calculation, performance metric evaluation, and result interpretation according to this selection.<br><br>Selecting the correct target class is particularly important in studies predicting outcomes such as disease presence, mortality, complications, or other clinical endpoints.',
    style: 'width: 700px;'
  }
},

projects_machine_learning_output: {
  tr: {
    caption: 'Makine Öğrenmesi Çıktı Değişkeni',
    content: '<b>Açıklama:</b> Bu alanda <b>tahmin edilmesi istenen çıktı parametresi</b> seçilir.<br><br>Seçilen tüm değişkenler kullanılarak, bu çıktı değişkenini tahmin etmeye yönelik <b>makine öğrenmesi modelleri</b> otomatik olarak üretilir.<br><br>Sistem; değişkenlerin <b>kategorik veya numerik</b> olma durumlarını dikkate alarak <b>hangi makine öğrenmesi algoritmalarının uygun olduğuna</b> kendisi karar verir ve tüm uygun modelleri uygular.<br><br>Uygulanan modeller, <b>doğruluk oranı en yüksekten en düşüğe</b> doğru sıralanarak tablo halinde sunulur.<br><br>Makine öğrenmesi eğitiminde, ilgili algoritmaların <b>varsayılan (default) parametreleri</b> kullanılır. Bu alanın amacı, veri seti için <b>hangi modelin daha uygun olduğunu görmek</b> veya <b>anlamlı bir model kurulup kurulamayacağını değerlendirmektir</b>.<br><br>Bu çıktılar <b>akademik amaçlarla</b> kullanılabilir; ancak <b>optimize edilmiş, üretim ortamına alınacak bir makine öğrenmesi modeli</b> bu alandan oluşturulmaz.',
    style: 'width: 740px;'
  },
  en: {
    caption: 'Machine Learning Output Variable',
    content: '<b>Description:</b> This field is used to select the <b>target output variable</b> to be predicted.<br><br>Using all selected variables, the system automatically generates <b>machine learning models</b> to predict the chosen output variable.<br><br>The system determines which algorithms are appropriate by considering whether variables are <b>categorical or numerical</b>, and applies all suitable models automatically.<br><br>The resulting models are presented in a table, <b>sorted from highest to lowest accuracy</b>.<br><br>Model training is performed using the <b>default parameters</b> of each algorithm. The purpose of this section is to evaluate <b>model suitability</b> and determine whether a meaningful predictive model can be established for the dataset.<br><br>While these results may be used for <b>academic purposes</b>, this section does not support building or deploying <b>optimized production-ready machine learning models</b>.',
    style: 'width: 740px;'
  }
},

projects_machine_learning_model_list: {
  tr: {
    caption: 'Makine Öğrenmesi Model Listesi',
    content: `
<b>Açıklama:</b> Seçilen tüm değişkenler kullanılarak, belirlenen çıktı değişkenini tahmin etmeye yönelik <b>makine öğrenmesi modelleri</b> sistem tarafından otomatik olarak oluşturulur.<br><br>

Sistem; değişkenlerin <b>kategorik veya numerik</b> olma durumlarını dikkate alarak <b>hangi algoritmaların uygun olduğuna</b> kendisi karar verir ve tüm uygun modelleri uygular. Modeller, <b>doğruluk oranına göre</b> yüksekten düşüğe sıralanarak tablo halinde sunulur.<br><br>

<b>Tabloda Yer Alan Parametrelerin Anlamları:</b>
<ul style="margin-left:16px;">
  <li><b>Output:</b> Tahmin edilmesi istenen hedef değişkendir.</li>
  <li><b>Model:</b> Kullanılan makine öğrenmesi algoritmasının adıdır.</li>
  <li><b>Test Size:</b> Veri setinin test (doğrulama) için ayrılan oranıdır.</li>
  <li><b>Accuracy:</b> Modelin tüm tahminler içindeki doğru tahmin oranıdır.</li>
  <li><b>ROC (AUC):</b> Modelin sınıfları ayırt edebilme başarısını gösterir.</li>
  <li><b>R² Score:</b> Regresyon modellerinde, çıktı değişkenindeki değişimin model tarafından ne kadarının açıklanabildiğini gösterir. 1’e yaklaştıkça model uyumu artar.</li>
  <li><b>MAE:</b> Ortalama mutlak hatadır. Gerçek değerler ile tahmin edilen değerler arasındaki ortalama mutlak farkı gösterir. Düşük olması daha iyidir.</li>
  <li><b>MSE:</b> Ortalama kare hatadır. Tahmin hatalarının karelerinin ortalamasını gösterir ve büyük hataları daha fazla cezalandırır. Düşük olması daha iyidir.</li>
  <li><b>RMSE:</b> Kök ortalama kare hatadır. MSE değerinin kareköküdür ve hatayı çıktı değişkeninin orijinal biriminde gösterir. Düşük olması daha iyidir.</li>
  <li><b>Brier Score:</b> Modelin tahmin ettiği olasılık değerleri ile gerçek sonuçlar arasındaki ortalama kare hatayı gösterir. Özellikle olasılık temelli sınıflandırma modellerinde kalibrasyon başarısını değerlendirmek için kullanılır. Düşük olması daha iyi kalibrasyon anlamına gelir.</li>
  <li><b>Precision (Binary):</b> Pozitif tahmin edilenlerin ne kadarının gerçekten pozitif olduğunu gösterir.</li>
  <li><b>Precision (Micro):</b> Tüm sınıflar birlikte değerlendirilerek hesaplanan hassasiyet değeridir.</li>
  <li><b>Precision (Macro):</b> Her sınıf için ayrı hesaplanıp ortalaması alınan hassasiyet değeridir.</li>
  <li><b>Precision (Weighted):</b> Sınıf dağılımları dikkate alınarak ağırlıklı hesaplanan hassasiyet değeridir.</li>

  <li><b>Recall (Binary):</b> Gerçek pozitiflerin ne kadarının doğru tahmin edildiğini gösterir.</li>
  <li><b>Recall (Micro):</b> Tüm sınıflar birlikte ele alınarak hesaplanan duyarlılık değeridir.</li>
  <li><b>Recall (Macro):</b> Her sınıf için ayrı hesaplanıp ortalaması alınan duyarlılık değeridir.</li>
  <li><b>Recall (Weighted):</b> Sınıf dağılımlarına göre ağırlıklandırılmış duyarlılık değeridir.</li>

  <li><b>F-Score (Binary):</b> Precision ve Recall değerlerinin dengeli birleşimidir.</li>
  <li><b>F-Score (Micro):</b> Tüm sınıflar birlikte değerlendirilerek hesaplanan F-Score değeridir.</li>
  <li><b>F-Score (Macro):</b> Her sınıf için ayrı hesaplanan F-Score değerlerinin ortalamasıdır.</li>
  <li><b>F-Score (Weighted):</b> Sınıf dağılımlarına göre ağırlıklandırılmış F-Score değeridir.</li>
</ul>

<br>
<b>Not:</b> Model eğitimleri algoritmaların <b>varsayılan (default) parametreleri</b> kullanılarak gerçekleştirilir. Bu alanın amacı; veri seti için <b>hangi modelin daha uygun olduğunu değerlendirmek</b> ve <b>anlamlı bir tahmin modeli kurulup kurulamayacağını gözlemlemektir</b>.
<br>
<br>

<b>Aşağıdaki formattaki metinler makalede kullanılabilir:</b>
<br>

<b>Machine Learning Procedure and Pipeline</b>
<br>
Statistical analyses were performed before starting the ML model. The ??? parameter was used as the output. Five classification ML models were included as support vector machine (SVM), decision tree (DT), random forest (RF), k-nearest neighbors (KNN), and logistic regression (LR). 30% was taken as the basis of the test size. Many power factors such as area under the curve (auc) value, accuracy rate, sensitivity, precision and F1 score were evaluated to check the power of the ML model.
<br>
<br>

<b>Aşağıdaki veri ön işleme süreci makale metoduna eklenmesi önerilir. Gereken bölümlerde ek düzenlemeler yapılabilir.</b>
<br>
<br>


<b>Data preprocessing</b>
<br>
Prior to statistical analysis and machine learning modeling, a standardized data preprocessing pipeline was implemented to ensure methodological consistency and analytical integrity. Only complete cases were included in the final dataset; observations with missing values in any of the relevant input variables were excluded from the analyses. This strategy was adopted to avoid potential bias introduced by data imputation and to maintain full interpretability of all model inputs. Continuous variables were examined for distributional characteristics using descriptive and normality-based assessments. No artificial transformation, rescaling, or discretization of continuous parameters was applied, as the objective was to preserve their original scale and real-world interpretability. Categorical variables were retained in their native binary or nominal form, as appropriate. For machine learning analyses, identical preprocessing procedures were applied uniformly across all data subsets used for model development and evaluation to prevent data leakage and ensure comparability. Data partitioning was performed after preprocessing, and no information from evaluation subsets was utilized during model training.
<br>
<br>
<b>Grup tahmini modeli ise sınıf dağılımı düzgün değilse bu durumda modelin doğruluğunu artırmak için çeşitli yöntemler kullanılır. Burada amaç optimizasyon olmadığından makalede aşağıdaki şekilde belirtilebilir.</b>
<br>
<br>

<b>Class Distribution and Handling of Imbalance</b>
<br>
The distribution of the classes was moderately imbalanced, with 300 x group cases and 100 y group cases. No synthetic oversampling or class re-weighting techniques (e.g., SMOTE or cost-sensitive learning) were applied. This decision was intentional, as the primary objective of the study was not to optimize predictive performance under artificially balanced conditions, but rather to model and reproduce real-world clinical classification patterns observed in routine practice. To mitigate potential bias, training and test splits were generated using stratified sampling to preserve the original class proportions across datasets. Moreover, model performance was evaluated using multiple complementary metrics beyond accuracy, including sensitivity, precision, F1 score, and area under the ROC curve.
<br>
<br>
<b>Parametrelerin girdi olarak kullanılmasında normalizasyon uygulanabiliyor. Burada gerçek veriler üzerinden model geliştirilebilme ihtimalini anlamaya çalıştığımız için buna gerek görmüyoruz. Bunu aşağıdaki şekilde makalede belirtebiliriz.</b>
<br>
<br>

<b>Feature Scaling</b>
<br>
Feature scaling (normalization or standardization) was not applied prior to model development. This decision was made deliberately to preserve the original scale and clinical interpretability of input variables, which are routinely evaluated and acted upon using absolute values in real-world practice. The primary objective of the modeling framework was to reflect real-world decision-making patterns rather than to optimize algorithmic performance under idealized conditions. A substantial proportion of the implemented algorithms were inherently robust to differences in feature scale, minimizing potential bias related to unscaled inputs. For algorithms known to be sensitive to feature magnitude, model stability and generalizability were evaluated through consistent performance across training, internal testing, and cross-validation. The observed concordance across these evaluation stages indicates that the absence of feature scaling did not materially influence model behavior or the validity of the study’s conclusions.
<br>
<br>
<b> Makine öğrenmesi model eğitiminde fonksiyona girdi olarak verilebilen çeşitli parametreler bulunmaktadır. Bu parametreler modelin daha iyi tahmin yapabilmesi için deneme ile optimize edilir. Burada temel amaç optimize model geliştirmekten ziyade tahmin edebilen model varlığını keşfetmek. Dolayısıyla bu makalede aşağıdaki şekilde belirtilebilir.</b>
<br>
<br>

<b>Hyperparameter Configuration</b>
<br>
Machine learning models were developed using default hyperparameter settings without additional optimization. This approach was intentionally adopted to reduce model complexity, enhance reproducibility, and emphasize interpretability, while allowing model performance to primarily reflect the intrinsic structure of the underlying data rather than optimization-driven effects. Model robustness and stability were evaluated through systematic internal validation procedures, including cross-validation and repeated train–test assessments. The consistency of model performance across these evaluations supports the methodological adequacy of this approach and suggests that the absence of hyperparameter tuning did not compromise the validity of the study’s primary conclusions.
<br>
<br>

<b>Eksternal validasyon yapılabilir. Bu durumda bir uzmanın aynı verilerdeki kararı ile modelin kararı kıyaslanır. Bu durumda aşağıdaki başlık makalede kullanılabilir.</b>
<br>
<br>

<b>Validation Procedure</b>
<br>
To assess the generalizability of the developed machine learning models, an independent validation analysis was conducted using a separate set of anonymized cases that were not involved in model development. These cases were processed using the same preprocessing pipeline applied in the primary analyses. Model predictions were generated without access to outcome labels. In parallel, an experienced domain expert independently evaluated the same cases based solely on the available input variables and assigned classifications corresponding to the reference outcomes. Both the expert assessment and the model predictions were performed in a blinded manner. Agreement between model outputs and expert classifications was subsequently evaluated to quantify concordance.

<br>
<br>

<b>Model doğruluk oranı % 100'e yakın olup çok yüksek ise modelin aşırı öğrenmesi problemi olabilir. Bununla ilgii makalede aşağıdaki metin kullanılabilir.</b>
<br>
<br>

<b>Overfitting Assessment</b>
<br>
To evaluate whether the observed predictive performance was attributable to model overfitting, a series of complementary analytical procedures were undertaken. First, model performance metrics obtained from the training and testing datasets were systematically compared for each model configuration. The absence of marked discrepancies between these estimates was interpreted as supportive, though not conclusive, evidence against substantial overfitting.

Second, five-fold cross-validation was performed within the training data to derive more robust and stable estimates of model performance across multiple data partitions. The consistency of accuracy and area under the receiver operating characteristic (ROC) curve values across cross-validation folds, as well as their concordance with hold-out testing results, suggests that model performance was not unduly dependent on a single data split. Collectively, these analyses indicate reasonable model stability, while acknowledging that predictive performance may remain influenced by the underlying cohort structure and data characteristics.

`,
    style: 'width: 780px;'
  },

  en: {
    caption: 'Machine Learning Model List',
    content: `
<b>Description:</b> Using all selected variables, the system automatically generates <b>machine learning models</b> to predict the specified output variable.<br><br>

The system evaluates whether variables are <b>categorical or numerical</b> and automatically determines <b>which machine learning algorithms are suitable</b>. All applicable models are trained and presented in a table, sorted from <b>highest to lowest performance</b>.<br><br>

<b>Meaning of the Parameters Displayed in the Table:</b>
<ul style="margin-left:16px;">
  <li><b>Output:</b> The target variable that the model aims to predict.</li>
  <li><b>Model:</b> The name of the machine learning algorithm used.</li>
  <li><b>Test Size:</b> The proportion of the dataset reserved for testing (validation).</li>
  <li><b>Accuracy:</b> The ratio of correctly predicted observations to total observations.</li>
  <li><b>ROC (AUC):</b> Indicates the model’s ability to distinguish between classes.</li>

  <li><b>R² Score:</b> In regression models, indicates how much of the variability in the output variable is explained by the model. Values closer to 1 indicate better model fit.</li>
  <li><b>MAE:</b> Mean Absolute Error. It represents the average absolute difference between the observed and predicted values. Lower values indicate better performance.</li>
  <li><b>MSE:</b> Mean Squared Error. It represents the average of squared prediction errors and penalizes larger errors more strongly. Lower values indicate better performance.</li>
  <li><b>RMSE:</b> Root Mean Squared Error. It is the square root of MSE and expresses the prediction error in the original unit of the output variable. Lower values indicate better performance.</li>
  <li><b>Brier Score:</b> Represents the mean squared difference between predicted probabilities and actual outcomes. It is commonly used to evaluate calibration performance in probability-based classification models. Lower values indicate better calibration.</li>
  <li><b>Precision (Binary):</b> Proportion of correctly predicted positive observations in binary classification.</li>
  <li><b>Precision (Micro):</b> Precision calculated globally across all classes.</li>
  <li><b>Precision (Macro):</b> Average precision calculated independently for each class.</li>
  <li><b>Precision (Weighted):</b> Precision weighted by the number of samples in each class.</li>

  <li><b>Recall (Binary):</b> Proportion of actual positive cases correctly identified.</li>
  <li><b>Recall (Micro):</b> Recall calculated globally across all classes.</li>
  <li><b>Recall (Macro):</b> Average recall calculated independently for each class.</li>
  <li><b>Recall (Weighted):</b> Recall weighted according to class frequencies.</li>

  <li><b>F-Score (Binary):</b> Harmonic mean of precision and recall for binary classification.</li>
  <li><b>F-Score (Micro):</b> F-score calculated globally across all classes.</li>
  <li><b>F-Score (Macro):</b> Average F-score calculated independently for each class.</li>
  <li><b>F-Score (Weighted):</b> F-score weighted by class distribution.</li>
</ul>

<br>
<b>Note:</b> All models are trained using the algorithms’ <b>default parameter settings</b>. The purpose of this section is to <b>evaluate model suitability</b> and <b>assess whether a meaningful predictive model can be established</b> for the given dataset. These outputs are intended for <b>exploratory and academic use</b> and are not optimized for production deployment.

<br>
<br>
<b>Text in the following format may be used in the article:</b>
<br>

<b>Machine Learning Procedure and Pipeline</b>
<br>
Statistical analyses were performed before starting the ML model. The ??? parameter was used as the output. Five classification ML models were included as support vector machine (SVM), decision tree (DT), random forest (RF), k-nearest neighbors (KNN), and logistic regression (LR). 30% was taken as the basis of the test size. Many power factors such as area under the curve (auc) value, accuracy rate, sensitivity, precision and F1 score were evaluated to check the power of the ML model.
<br>
<br>

<b>It is recommended to add the following data preprocessing steps to the article methodology. Additional adjustments can be made in the necessary sections.</b>

<br>
<br>
<b>Data preprocessing</b>
<br>
Prior to statistical analysis and machine learning modeling, a standardized data preprocessing pipeline was implemented to ensure methodological consistency and analytical integrity. Only complete cases were included in the final dataset; observations with missing values in any of the relevant input variables were excluded from the analyses. This strategy was adopted to avoid potential bias introduced by data imputation and to maintain full interpretability of all model inputs. Continuous variables were examined for distributional characteristics using descriptive and normality-based assessments. No artificial transformation, rescaling, or discretization of continuous parameters was applied, as the objective was to preserve their original scale and real-world interpretability. Categorical variables were retained in their native binary or nominal form, as appropriate. For machine learning analyses, identical preprocessing procedures were applied uniformly across all data subsets used for model development and evaluation to prevent data leakage and ensure comparability. Data partitioning was performed after preprocessing, and no information from evaluation subsets was utilized during model training.
<br>
<br>

<b>If the class distribution is not uniform in the group estimation model, various methods are used to improve the accuracy of the model. Since the aim here is not optimization, it can be stated in the article as follows.</b>
<br>
<br>

<b>Class Distribution and Handling of Imbalance</b>
<br>
The distribution of the classes was moderately imbalanced, with 300 x group cases and 100 y group cases. No synthetic oversampling or class re-weighting techniques (e.g., SMOTE or cost-sensitive learning) were applied. This decision was intentional, as the primary objective of the study was not to optimize predictive performance under artificially balanced conditions, but rather to model and reproduce real-world clinical classification patterns observed in routine practice. To mitigate potential bias, training and test splits were generated using stratified sampling to preserve the original class proportions across datasets. Moreover, model performance was evaluated using multiple complementary metrics beyond accuracy, including sensitivity, precision, F1 score, and area under the ROC curve.
<br>
<br>

<b>Normalization can be applied when using parameters as input. However, we don't see the need for it here because we are trying to understand the possibility of developing a model based on real data. We can state this in the article as follows.</b>
<br>
<br>

<b>Feature Scaling</b>
<br>
Feature scaling (normalization or standardization) was not applied prior to model development. This decision was made deliberately to preserve the original scale and clinical interpretability of input variables, which are routinely evaluated and acted upon using absolute values in real-world practice. The primary objective of the modeling framework was to reflect real-world decision-making patterns rather than to optimize algorithmic performance under idealized conditions. A substantial proportion of the implemented algorithms were inherently robust to differences in feature scale, minimizing potential bias related to unscaled inputs. For algorithms known to be sensitive to feature magnitude, model stability and generalizability were evaluated through consistent performance across training, internal testing, and cross-validation. The observed concordance across these evaluation stages indicates that the absence of feature scaling did not materially influence model behavior or the validity of the study’s conclusions.
<br>
<br>
<b> In machine learning model training, there are various parameters that can be given as input to the function. These parameters are optimized through trial and error so that the model can make better predictions. The main goal here is not to develop an optimized model, but to discover the existence of a model that can make predictions. Therefore, this can be stated in this article as follows.</b>
<br>
<br>

<b>Hyperparameter Configuration</b>
<br>
Machine learning models were developed using default hyperparameter settings without additional optimization. This approach was intentionally adopted to reduce model complexity, enhance reproducibility, and emphasize interpretability, while allowing model performance to primarily reflect the intrinsic structure of the underlying data rather than optimization-driven effects. Model robustness and stability were evaluated through systematic internal validation procedures, including cross-validation and repeated train–test assessments. The consistency of model performance across these evaluations supports the methodological adequacy of this approach and suggests that the absence of hyperparameter tuning did not compromise the validity of the study’s primary conclusions.
<br>
<br>

<b>External validation can be performed. In this case, the model's decision is compared with the decision of an expert on the same data. In this case, the following heading can be used in the article.</b>
<br>
<br>

<b>Validation Procedure</b>
<br>
To assess the generalizability of the developed machine learning models, an independent validation analysis was conducted using a separate set of anonymized cases that were not involved in model development. These cases were processed using the same preprocessing pipeline applied in the primary analyses. Model predictions were generated without access to outcome labels. In parallel, an experienced domain expert independently evaluated the same cases based solely on the available input variables and assigned classifications corresponding to the reference outcomes. Both the expert assessment and the model predictions were performed in a blinded manner. Agreement between model outputs and expert classifications was subsequently evaluated to quantify concordance.
<br>
<br>

<b>If the model's accuracy rate is close to 100%, which is very high, it may indicate an overlearning problem. The following text from an article on this topic can be used. </b>
<br>
<br>

<b>Overfitting Assessment</b>
<br>
To evaluate whether the observed predictive performance was attributable to model overfitting, a series of complementary analytical procedures were undertaken. First, model performance metrics obtained from the training and testing datasets were systematically compared for each model configuration. The absence of marked discrepancies between these estimates was interpreted as supportive, though not conclusive, evidence against substantial overfitting.

Second, five-fold cross-validation was performed within the training data to derive more robust and stable estimates of model performance across multiple data partitions. The consistency of accuracy and area under the receiver operating characteristic (ROC) curve values across cross-validation folds, as well as their concordance with hold-out testing results, suggests that model performance was not unduly dependent on a single data split. Collectively, these analyses indicate reasonable model stability, while acknowledging that predictive performance may remain influenced by the underlying cohort structure and data characteristics.

`,
    style: 'width: 780px;'
  }
},

projects_report_notes: {
  tr: {
    caption: 'Rapor Notları',
    content: 'Analizler sonucunda elde edilen <b>istatistiksel ve analitik metinler</b>, her bir metnin yanında yer alan <b>“Rapora Ekle”</b> butonu kullanılarak bu alana eklenebilir.<br><br>Eklenen cümleler burada <b>özet halinde</b> listelenir ve rapor, makale veya sunum çıktılarında kullanılmak üzere derlenmiş bir içerik oluşturur.',
    style: 'width: 520px;'
  },
  en: {
    caption: 'Report Notes',
    content: 'The <b>statistical and analytical texts</b> generated during the analysis can be added to this section using the <b>“Add to Report”</b> button located next to each result text.<br><br>The selected sentences are displayed here as a <b>summary</b>, creating a compiled content that can be used in reports, manuscripts, or presentation outputs.',
    style: 'width: 520px;'
  }
},

projects_columns_new_column: {
  tr: {
    caption: 'Yeni Kolon Ekleme',
    content: '<b>Açıklama:</b> Excel üzerinden yüklenen projelerde <b>yalnızca manuel kolonlar</b> eklenebilir.<br><br>Veritabanı ile entegre çalışan sistemlerde ise, veritabanına doğrudan bağlanan <b>katman kolonları (WDM)</b> da eklenebilmektedir.<br><br>Yeni bir kolon ekledikten sonra; <b>kolon adını düzenlemeyi</b>, <b>uygun veri tipini seçmeyi</b> ve yapılan değişikliklerin geçerli olması için mutlaka <b>Kaydet</b> butonuna tıklamayı unutmayınız.',
    style: 'width: 620px;'
  },
  en: {
    caption: 'Add New Column',
    content: '<b>Description:</b> In projects created by uploading Excel files, only <b>manual columns</b> can be added.<br><br>In database-integrated systems, <b>layer columns (WDM)</b> that connect directly to the database can also be added.<br><br>After adding a new column, make sure to <b>edit the column name</b>, <b>select the appropriate data type</b>, and click the <b>Save</b> button to apply your changes.',
    style: 'width: 620px;'
  }
},

projects_columns_type: {
  tr: {
    caption: 'Kolon Tipi',
    content: '<b>Açıklama:</b> Kolon tipi seçimi, sistemin veriyi <b>nasıl analiz edeceğini</b> belirleyen en kritik adımdır.<br><br>\
<ul style="margin-left:16px;">\
<li><b>select (kategorik):</b> Seçenekli, sınırlı sayıda değer alan veriler için kullanılır. Örn: cinsiyet, evet/hayır, kurum adı. Aynı verinin farklı yazımlarla (male / mmale gibi) çoğalması durumunda sistem düzeltme imkânı sunar.</li>\
<li><b>integer (tam sayı):</b> Ondalık içermeyen sayısal veriler için kullanılır. Örn: yaş, vaka sayısı, gün sayısı.</li>\
<li><b>float (ondalıklı sayı):</b> Ondalık hassasiyet gerektiren sayısal veriler için kullanılır. Örn: laboratuvar ölçümleri, oranlar, skorlar.</li>\
<li><b>text:</b> Analize uygun olmayan, serbest metin içeren alanlar için kullanılır. Örn: açıklama, not, serbest yorum.</li>\
<li><b>datetime:</b> Tarih veya tarih-saat bilgisi içeren veriler için kullanılır. Örn: 2025-01-01 veya 2025-01-01 12:45.</li>\
</ul><br>\
<b>Önemli:</b> Bazı veriler sayısal gibi görünüp aslında kategorik olabilir (örn: evre 1–2–3). Bu durumda <b>select</b> tercih edilmelidir. Tersine, kategorik gibi görünen bazı verilerde sayısal analiz gerekebilir; bu durumda <b>integer</b> veya <b>float</b> seçilmelidir.',
    style: 'width: 700px;'
  },
  en: {
    caption: 'Column Type',
    content: '<b>Description:</b> Selecting the correct column type is a critical step, as it defines <b>how the system will analyze the data</b>.<br><br>\
<ul style="margin-left:16px;">\
<li><b>select (categorical):</b> Used for variables with a limited set of possible values. Example: gender, yes/no, institution name. The system allows correction when the same category appears with different spellings.</li>\
<li><b>integer:</b> Used for numeric values without decimals. Example: age, case count, number of days.</li>\
<li><b>float:</b> Used for numeric values requiring decimal precision. Example: laboratory measurements, ratios, scores.</li>\
<li><b>text:</b> Used for free-text fields that are not suitable for analysis. Example: notes, descriptions, comments.</li>\
<li><b>datetime:</b> Used for date or date-time values. Example: 2025-01-01 or 2025-01-01 12:45.</li>\
</ul><br>\
<b>Important:</b> Some variables may appear numeric but are actually categorical (e.g., stage 1–2–3); in such cases, <b>select</b> should be chosen. Conversely, some variables that look categorical may require numeric analysis, in which case <b>integer</b> or <b>float</b> should be selected.',
    style: 'width: 700px;'
  }
},

projects_column_data_type: {
  tr: {
    caption: 'Kolon Veri Üretim Tipi',
    content: '<b>Açıklama:</b> Bu alan, kolon verisinin <b>nasıl üretileceğini</b> tanımlar.<br><br>\
    <ul style="margin-left:16px;">\
    <li><b>Manuel:</b> Bu seçenek, özellikle <b>seçenekli (kategorik)</b> veriler için kullanılır. Manuel kolon tipinde, seçenekler doğrudan kullanıcı tarafından girilir veya <b>seçeneklere kural atayarak</b> üretilir.</li>\
    <li><b>Sütun Kuralı ve Fonksiyonları:</b> Bu seçenek tercih edildiğinde, kolon verileri <b>mevcut kolonlar üzerinden</b> matematiksel fonksiyonlar, kural tabanlı algoritmalar ve tarihsel işlemler kullanılarak üretilir. Hem <b>kategorik</b> hem <b>numerik</b> hem de <b>tarihsel (datetime)</b> veriler bu yöntemle oluşturulabilir.</li>\
    </ul>',
    style: 'width: 700px;'
  },
  en: {
    caption: 'Column Data Generation Type',
    content: '<b>Description:</b> This field defines <b>how the column data will be generated</b>.<br><br>\
    <ul style="margin-left:16px;">\
      <li>\
        <b>Manual:</b> This option is primarily used for <b>option-based (categorical)</b> data.  \
        In the manual column type, options are either entered directly by the user or generated by <b>assigning rules to predefined options</b>.\
      </li>\
      <li>\
        <b>Column Rules and Functions:</b> When this option is selected, column data is generated <b>based on existing columns</b> using mathematical functions, rule-based algorithms, and temporal operations.  \
        <b>Categorical</b>, <b>numeric</b>, and <b>temporal (datetime)</b> data can all be created using this method.\
      </li>\
    </ul>',
    style: 'width: 700px;'
  }
},

projects_column_rule_and_functions: {
  tr: {
    caption: 'Kolon Kuralı ve Fonksiyonları',
    content: '<b>Açıklama:</b> Bu bölümde, kolon verileri <b>fonksiyonlar ve kurallar</b> kullanılarak dinamik şekilde üretilir.<br><br>\
Fonksiyon eklemek için <b>Fonksiyon Ekle</b> butonuna tıklanır. Bir kolona <b>birden fazla fonksiyon</b> eklenebilir. Fonksiyonlar <b>sırayla değerlendirilir</b> ve <b>son pozitif (doğru) dönen fonksiyonun sonucu</b> hücreye yazılır.<br><br>\
Her fonksiyon için bir <b>doğruluk koşulu (kural)</b> tanımlanabilir. Kural alanı, <b>yıldız (*) simgesine</b> tıklanarak açılır ve diğer kolonlar baz alınarak oluşturulur.<br><br>\
<b>Örnek:</b><br>\
Eğer <i>cinsiyet</i> kolonu <b>erkek</b> ise skor = <i>col1 × 2</i>,<br>\
Eğer <i>cinsiyet</i> kolonu <b>kadın</b> ise skor = <i>col1 × 3</i> olacak şekilde bir modelleme yapılabilir.<br><br>\
Bu durumda;<br>\
<ul style="margin-left:16px;">\
<li>Fonksiyon alanına <i>col1 * 2</i> yazılır,</li>\
<li>Kural alanına <i>cinsiyet = erkek</i> tanımlanır.</li>\
<li>Yeni bir fonksiyon eklenir, fonksiyon <i>col1 * 3</i> olarak değiştirilir,</li>\
<li>Kural <i>cinsiyet = kadın</i> şeklinde düzenlenir.</li>\
</ul><br>\
Sistem fonksiyonları yukarıdan aşağıya doğru analiz eder ve <b>ilk doğru koşulu geçen değil, en son doğru dönen fonksiyonun sonucunu</b> hücreye yazar.',
    style: 'width: 740px;'
  },
  en: {
    caption: 'Column Rules and Functions',
    content: '<b>Description:</b> In this section, column values are dynamically generated using <b>functions and rules</b>.<br><br>\
Functions are added by clicking the <b>Add Function</b> button. A column may contain <b>multiple functions</b>. These functions are <b>evaluated sequentially</b>, and the <b>value returned by the last function that evaluates to true</b> is written into the cell.<br><br>\
Each function may include a <b>validation condition (rule)</b>. Rules are created by clicking the <b>asterisk (*) icon</b> and can reference values from other columns.<br><br>\
<b>Example:</b><br>\
If the <i>gender</i> column is <b>male</b>, score = <i>col1 × 2</i>,<br>\
If the <i>gender</i> column is <b>female</b>, score = <i>col1 × 3</i>.<br><br>\
In this case:<br>\
<ul style="margin-left:16px;">\
<li>The function field is set to <i>col1 * 2</i>,</li>\
<li>The rule is defined as <i>gender = male</i>,</li>\
<li>A new function is added with <i>col1 * 3</i>,</li>\
<li>The rule is updated to <i>gender = female</i>.</li>\
</ul><br>\
The system evaluates functions from top to bottom and writes the <b>result of the last function whose condition is satisfied</b> into the cell.',
    style: 'width: 740px;'
  }
},

add_total_row: {
  tr: {
    caption: 'Seçenekli Verilerin Total Değerlerinin Yazılması',
    content: '<b>Açıklama:</b> Kategorik verilerin seçeneklerine ait total değerlerin de tablonun en altında yazılması istenirse evet olarak seçilir.',
    style: 'width: 500px;'
  },
  en: {
    caption: 'Writing the total values of optional data',
    content: '<b>Explanation:</b> If you want the total values for the options in the categorical data to also be written at the bottom of the table, select "yes".',
    style: 'width: 500px;'
  }
},

dataset_cancel_information: {
  tr: {
    caption: 'Dataseti pasife çekmek',
    content: 'Dataseti pasife çekmek için lütfen destek ile iletişime geçin.',
    style: 'width: 420px;'
  },
  en: {
    caption: 'To passive dataset',
    content: 'To deactivate the dataset, please contact support.',
    style: 'width: 420px;'
  }
},

article_to_passive: {
  tr: {
    caption: 'Makaleyi pasife çekmek',
    content: 'Makaleyi pasife çekmek için lütfen destek ile iletişime geçin.',
    style: 'width: 420px;'
  },
  en: {
    caption: 'To passive article',
    content: 'To deactivate the article, please contact support.',
    style: 'width: 420px;'
  }
},

research_methodology_and_article_management: {
  tr: {
    caption: 'Makale veya araştırma metodolojisi ekleme ve yönetme',
    content: 'Makale veya araştırma metodolojisi ekleme ve yönetme için sağ taraftaki buton grubundan "Araştırma Metodolojisi ve Makale Yönetimi" seçeneğine tıklayın.\n Birden fazla araştırmacı aynı metodoloji üzerine çalışma yapmaması için makale yayınlanmamış fakat üzerinde çalışıyor olduğunuz metodolojileri de buraya eklemelisiniz.',
    style: 'width: 520px;'
  },
  en: {
    caption: 'To add and manage articles or research methodologies',
    content: 'To add and manage articles or research methodologies, click on the "Research Methodology and Article Management" option in the button group on the right.\n To prevent multiple researchers from working on the same methodology, you should also add any methodologies you are working on but haven\'t yet published in articles.',
    style: 'width: 520px;'
  }
},

statistics_parameters: {
    tr: {
      caption: 'Regresyon İstatistik Parametreleri (Yorumlu)',
      content: `
        <b>Genel Regresyon Parametreleri</b>
        <table border="1" cellpadding="6" cellspacing="0"
               style="border-collapse:collapse;width:100%;margin-top:6px;">
          <tr>
            <th style="width: 220px;">Parametre</th>
            <th>Açıklama ve Değer Bazlı Yorum</th>
          </tr>

          <tr>
            <td><b>β (Katsayı)</b></td>
            <td>
              Bağımsız değişkenin sonuç üzerindeki etkisinin yönünü ve büyüklüğünü gösterir.
              β &gt; 0 → artış yönlü etki,
              β &lt; 0 → azalış yönlü etki.
              Mutlak değerin büyümesi etkinin gücünün arttığını gösterir.
            </td>
          </tr>

          <tr>
            <td><b>Odds Ratio (OR)</b></td>
            <td>
              Odds Ratio (OR), bir değişkendeki 1 birimlik artışın sonucun olma olasılığını kaç kat değiştirdiğini gösterir. OR=1 etki yok, 1–1.5 modest, 1.5–2 moderate, ≥2 strong etkiyi ifade eder. Ancak çok büyük veya sonsuz OR değerleri genellikle model kararsızlığına işaret eder ve mutlaka güven aralığı ve p-değeri ile birlikte değerlendirilmelidir.
              β katsayısının üstel dönüşümüdür (exp(β)).
              OR = 1 → etki yok,
              1–1.5 → zayıf,
              1.5–2 → orta,
              ≥ 2 → güçlü etki.
              OR &lt; 1 sonuç olasılığında azalışı gösterir.
            </td>
          </tr>

          <tr>
            <td><b>P-value</b></td>
            <td>
              Katsayının istatistiksel anlamlılığını gösterir.
              p &lt; 0.05 → anlamlı,
              0.05 ≤ p &lt; 0.10 → sınırda ilişki,
              p ≥ 0.10 → anlamsız.
            </td>
          </tr>

          <tr>
            <td><b>T-value / Z-value</b></td>
            <td>
              Katsayının standart hataya oranıdır.
              |t| ≥ 2 → güçlü kanıt,
              1.5–2 → orta düzey,
              &lt; 1.5 → zayıf kanıt.
            </td>
          </tr>

          <tr>
            <td><b>AIC</b></td>
            <td>
              Model uyumu ve karmaşıklığını birlikte değerlendirir.
              Daha düşük AIC değeri daha iyi model uyumuna işaret eder.
              Modeller arası karşılaştırmada kullanılır.
            </td>
          </tr>

          <tr>
            <td><b>BIC</b></td>
            <td>
              AIC’ye benzer ancak karmaşıklığı daha ağır cezalandırır.
              Büyük örneklemlerde daha muhafazakâr bir ölçüttür.
            </td>
          </tr>

          <tr>
            <td><b>Log-Likelihood (LLF)</b></td>
            <td>
              Modelin veriyi açıklama başarısını gösterir.
              Daha yüksek (daha az negatif) değerler daha iyi uyuma işaret eder.
            </td>
          </tr>

          <tr>
            <td><b>R²</b></td>
            <td>
              Sonuç değişkenindeki varyansın model tarafından açıklanan oranıdır.
              Daha yüksek R² daha güçlü açıklayıcılığı gösterir.
            </td>
          </tr>

          <tr>
            <td><b>Adjusted R²</b></td>
            <td>
              Değişken sayısına göre düzeltilmiş açıklanan varyanstır.
              Çok değişkenli modellerde tercih edilir.
            </td>
          </tr>

          <tr>
            <td><b>F-statistic / F p-value</b></td>
            <td>
              Modelin bütün olarak anlamlı olup olmadığını test eder.
              F p-value &lt; 0.05 → model genel olarak anlamlıdır.
            </td>
          </tr>

          <tr>
            <td><b>df_model</b></td>
            <td>
              Modele dahil edilen bağımsız değişken sayısını yansıtır.
              Gözlem sayısına oranla yüksek olması aşırı uyum riskini artırır.
            </td>
          </tr>

          <tr>
            <td><b>df_resid</b></td>
            <td>
              Artık serbestlik derecesidir.
              Düşük değerler modelin aşırı karmaşık olabileceğini düşündürür.
            </td>
          </tr>

          <tr>
            <td><b>Nobs</b></td>
            <td>
              Analizde kullanılan gözlem sayısıdır.
              Genel kural olarak değişken başına ≥10 gözlem önerilir.
            </td>
          </tr>

          <tr>
            <td><b>SSR</b></td>
            <td>
              Artık kareler toplamıdır.
              Düşük SSR, model hatasının daha az olduğunu gösterir.
            </td>
          </tr>

          <tr>
            <td><b>MSE</b></td>
            <td>
              Ortalama kare hatadır.
              Daha düşük MSE, daha iyi model performansına işaret eder.
            </td>
          </tr>

          <tr>
            <td><b>Condition Number</b></td>
            <td>
              Çoklu doğrusal bağlantıyı (multicollinearity) değerlendirir.
              &lt; 30 → sorun yok,
              30–100 → orta,
              &gt; 100 → ciddi multicollinearity riski.
            </td>
          </tr>

          <tr>
            <td><b>Eigenvalues</b></td>
            <td>
              Tasarım matrisinin yapısını gösterir.
              Çok küçük eigenvalue değerleri ciddi multicollinearity göstergesi olabilir.
            </td>
          </tr>

          <tr>
            <td><b>Scale</b></td>
            <td>
              Modelin hata ölçeğini ifade eder.
              Bazı modellerde sabit kabul edilir ve yorum açısından sınırlı öneme sahiptir.
            </td>
          </tr>
        </table>

        <br>
        <b>Yorum Notu:</b>
        Model parametreleri birlikte değerlendirilmelidir.
        Tek bir ölçüt modelin kalitesini tam olarak yansıtmaz.
        Aşırı uyum, çoklu doğrusal bağlantı veya yetersiz örneklem durumlarında
        parametrelerin klinik veya bilimsel yorumu dikkatle yapılmalıdır.
      `,
      style: 'width: 1000px;'
    },
    en: {
    caption: 'Regression Statistical Parameters (Interpretation Guide)',
    content: `
      <b>General Regression Parameters</b>
      <table border="1" cellpadding="6" cellspacing="0"
             style="border-collapse:collapse;width:100%;margin-top:6px;">
        <tr>
          <th style="width: 220px;">Parameter</th>
          <th>Description and Value-Based Interpretation</th>
        </tr>

        <tr>
          <td><b>β (Coefficient)</b></td>
          <td>
            Represents the direction and magnitude of the effect.
            β &gt; 0 indicates an increasing effect, β &lt; 0 a decreasing effect.
            Larger absolute values indicate stronger effects.
          </td>
        </tr>

        <tr>
          <td><b>Odds Ratio (OR)</b></td>
          <td>
            The Odds Ratio (OR) indicates how many times a one-unit increase in a variable changes the probability of an outcome. An OR of 1 indicates no effect, 1–1.5 indicates a modest effect, 1.5–2 indicates a moderate effect, and ≥2 indicates a strong effect. However, very large or infinite OR values generally indicate model instability and should always be evaluated in conjunction with the confidence interval and p-value.
            Exponentiated coefficient (exp(β)).
            OR = 1 no effect,
            1–1.5 modest,
            1.5–2 moderate,
            ≥ 2 strong effect.
          </td>
        </tr>

        <tr>
          <td><b>P-value</b></td>
          <td>
            Indicates statistical significance.
            p &lt; 0.05 significant,
            0.05 ≤ p &lt; 0.10 borderline,
            ≥ 0.10 not significant.
          </td>
        </tr>

        <tr>
          <td><b>T-value / Z-value</b></td>
          <td>
            Ratio of coefficient to its standard error.
            |t| ≥ 2 strong evidence,
            1.5–2 moderate,
            &lt; 1.5 weak evidence.
          </td>
        </tr>

        <tr>
          <td><b>AIC</b></td>
          <td>
            Combines model fit and complexity.
            Lower values indicate better model fit.
          </td>
        </tr>

        <tr>
          <td><b>BIC</b></td>
          <td>
            Similar to AIC but penalizes complexity more strongly.
          </td>
        </tr>

        <tr>
          <td><b>Log-Likelihood</b></td>
          <td>
            Measures how well the model explains the observed data.
            Higher values indicate better fit.
          </td>
        </tr>

        <tr>
          <td><b>R² / Adjusted R²</b></td>
          <td>
            Proportion of variance explained by the model.
            Adjusted R² accounts for the number of predictors.
          </td>
        </tr>

        <tr>
          <td><b>F-statistic / F p-value</b></td>
          <td>
            Tests overall model significance.
            p &lt; 0.05 indicates a statistically significant model.
          </td>
        </tr>

        <tr>
          <td><b>df_model / df_resid</b></td>
          <td>
            Reflect model complexity and residual freedom.
          </td>
        </tr>

        <tr>
          <td><b>Nobs</b></td>
          <td>
            Number of observations.
            A common rule of thumb is ≥10 observations per predictor.
          </td>
        </tr>

        <tr>
          <td><b>SSR / MSE</b></td>
          <td>
            Reflect model error.
            Lower values indicate better performance.
          </td>
        </tr>

        <tr>
          <td><b>Condition Number</b></td>
          <td>
            Assesses multicollinearity.
            &lt; 30 acceptable,
            30–100 moderate,
            &gt; 100 severe multicollinearity.
          </td>
        </tr>

        <tr>
          <td><b>Eigenvalues</b></td>
          <td>
            Very small eigenvalues may indicate multicollinearity issues.
          </td>
        </tr>

        <tr>
          <td><b>Scale</b></td>
          <td>
            Error scale parameter.
            Often fixed and of limited interpretive importance.
          </td>
        </tr>
      </table>

      <br>
      <b>Interpretation Note:</b>
      No single statistic fully describes model quality.
      Parameters should be interpreted collectively,
      considering sample size, model assumptions, and clinical relevance.
    `,
    style: 'width: 1000px;'
  }
},


};


export { data };

























